
// import React, { useState, useEffect, useRef } from 'react';
// import { Button, } from 'react-bootstrap';
// import './CardComponent.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import bg2 from '../Theams/bg2.jpg';
// import bg3 from '../Theams/bg3.jpg';
// import { LogOut } from "lucide-react";
// import { Link } from "react-router-dom";
// import { Rnd } from "react-rnd";
// import { FaTextHeight, FaUpload, FaImage, FaTrash, FaClone, FaMinus } from "react-icons/fa";
// import Modal from "react-modal";
// import { useNavigate } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import QRCodeWithLogo from '../QRCode/QRCodeWithLogo';
// import { FaArrowLeft, FaArrowRight, FaEye } from 'react-icons/fa';
// import { FaSave, FaTimes } from 'react-icons/fa';
// import { FaPlus, FaBold, FaItalic, FaChevronDown, FaCheck } from "react-icons/fa";


// Modal.setAppElement("#root");

// const Vfccard = () => {



//   const [userEmail, setUserEmail] = useState(null);
//   const [websiteUrl, setWebsiteUrl] = useState(null);


//   const [showModal, setShowModal] = useState(false);
//   const [selectedImagee, setSelectedImagee] = useState("");
//   const [selectedImageeBack, setSelectedImageeBack] = useState("");

//   const [showModall, setShowModall] = useState(false);
//   const [isEditButtonVisible, setIsEditButtonVisible] = useState(true);
//   const [images1, setImages1] = useState([]);
//   const [cards, setCards] = useState([])
//   const [selectedImage, setSelectedImage] = useState({
//     image1: null,
//     image2: null,
//   });




//   useEffect(() => {
//     const email = sessionStorage.getItem("email");
//     if (!email) return;
//     const fetchExistingCard = async () => {
//       try {
//         const response = await axios.get('https://api.nfcdesignstudio.com/API/v1/api/getform');
//         const allCards = response.data;
//         const existingCard = allCards.find(card => card.email?.trim() === email?.trim());
//         console.log(existingCard);
//         if (existingCard) {
//           setUserEmail(existingCard.email);
//           setWebsiteUrl(existingCard.websiteUrl);
//         }
//       } catch (err) {
//         console.error("Error fetching existing card:", err);
//       }
//     };
//     fetchExistingCard();
//   }, []);


//   useEffect(() => {
//     if (!websiteUrl) return;

//     const fetchWebsiteData = async () => {
//       try {
//         console.log("Calling API with:", websiteUrl);

//         const response = await axios.get(`https://api.nfcdesignstudio.com/API/v1/${websiteUrl}`
//         );

//         if (Array.isArray(response.data) && response.data.length > 0) {
//           setCards(response.data);
//         } else {
//           setCards(response.data);
//         }

//         setImages1(response.data.images || []);
//       } catch (error) {
//         console.error("Error fetching website data:", error);
//       }
//     };
//     fetchWebsiteData();
//   }, [websiteUrl]);


//   console.log(cards)


//   const websiteurl = (`https://nfcdesignstudio.com/cardurl/${websiteUrl}`);

//   const qrCodeSize = 256; // Size of the QR code
//   const logoSize = 80;    // Size of the logo/image
//   const logoMargin = 20;  // Margin around the logo











//   const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

//   const handleImageLoad = (e) => {
//     const { naturalWidth, naturalHeight } = e.target;
//     setImageDimensions({ width: naturalWidth, height: naturalHeight });
//   };

//   const { width, height } = imageDimensions;

//   // Check if the image is square, rectangular, or circular
//   const isSquare = width === height;
//   const isCircle = width === height && width > 100; // You can adjust the threshold for circle size
//   const [isMobile, setIsMobile] = useState(false);

//   useEffect(() => {
//     // Function to check if the device is mobile
//     const checkMobile = () => setIsMobile(window.innerWidth <= 576);

//     // Initial check on mount
//     checkMobile();

//     // Add event listener to handle resize
//     window.addEventListener('resize', checkMobile);

//     // Clean up event listener on unmount
//     return () => {
//       window.removeEventListener('resize', checkMobile);
//     };
//   }, []);


//   const [showProfileModal, setShowProfileModal] = useState(false);

//   const handleProfileModalOpen = () => setShowProfileModal(true);
//   const handleProfileModalClose = () => setShowProfileModal(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [imageBlob, setImageBlob] = useState(null);
//   const [imageUrl, setImageUrl] = useState('');
//   const cardContainerRef = useRef();





//   const [selectedBg, setSelectedBg] = useState(bg3); // Default background

//   const bgStyles = {
//     // [bg1]: {
//     //   color: 'white',
//     //     fontFamily: 'Courier New, monospace'

//     // },
//     [bg2]: { fontFamily: 'Georgia, serif' },
//     [bg3]: { fontFamily: 'Arial, sans-serif' }
//   };
//   const currentStyle = bgStyles[selectedBg] || {};

//   const [showPopupTheme, setShowPopupTheme] = useState(false);
//   const [selectedThemeIndex, setSelectedThemeIndex] = useState(null);
//   const [tempSelectedBg, setTempSelectedBg] = useState(null);
//   useEffect(() => {
//     if (showPopupTheme) {
//       setTempSelectedBg(selectedBg);
//     }
//   }, [showPopupTheme]);

//   // new card 
//   const banner =
//     cards.image2 && cards.image2.trim() !== "" && cards.image2.toUpperCase() !== "NULL"
//       ? cards.image2
//       : images1 && images1.length > 0 && images1[0] && images1[0].trim() !== "" && images1[0].toUpperCase() !== "NULL"
//         ? images1[0]
//         : null;


//   const [page, setPage] = useState("mycard");
//   const [searchTerm, setSearchTerm] = useState('');

//   const handleSearch = () => {

//     console.log('Searching for:', searchTerm);

//   };

//   //==============================================
//   //==============================================


//   const STORAGE_KEY = "vfc_card_elements_v1";
//   const STORAGE_KEY_BACK = "vfc_card_elementsBack_v2";


//   const [showTextModal, setShowTextModal] = useState(false);
//   const [showImageModal, setShowImageModal] = useState(false);


//   const [showTextModalBack, setShowTextModalBack] = useState(false);
//   const [showImageModalBack, setShowImageModalBack] = useState(false);


//   const [imageShape, setImageShape] = useState("square");
//   const [imageFit, setImageFit] = useState("cover");


//   // const [elements, setElements] = useState(() => {
//   //   try {
//   //     return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
//   //   } catch {
//   //     return [];
//   //   }
//   // });

//   const [elements, setElements] = useState(() => {
//     try {
//       const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));

//       // Ensure it is always an array
//       return Array.isArray(stored) ? stored : [];
//     } catch (err) {
//       return [];
//     }
//   });


//   // Back card elemets

//   const [elementsBack, setElementsBack] = useState(() => {
//     try {
//       const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));

//       // Ensure it is always an array
//       return Array.isArray(stored) ? stored : [];
//     } catch (err) {
//       return [];
//     }
//   });



//   const [selectedId, setSelectedId] = useState(null);
//   const [showOrientationModal, setShowOrientationModal] = useState(false);
//   const [orientation, setOrientation] = useState("horizontal"); // horizontal | vertical
//   const [zoom, setZoom] = useState(1);

//   // toolbar states (applied to selected element)
//   const [fontFamily, setFontFamily] = useState("Arimo");
//   const [fontSize, setFontSize] = useState(24);
//   const [fontColor, setFontColor] = useState("#111111");
//   const [isBold, setIsBold] = useState(false);
//   const [isItalic, setIsItalic] = useState(false);
//   const [textAlign, setTextAlign] = useState("left");

//   // sample uploaded image path (developer-provided uploaded file)
//   const sampleLogoUrl = "/mnt/data/3fb6be9d-c971-4e00-b90f-b53691650458.png";

//   useEffect(() => {
//     sessionStorage.setItem(STORAGE_KEY_BACK, JSON.stringify(elementsBack));
//   }, [elementsBack]);


//   useEffect(() => {
//     // When selection changes, populate toolbar states from element
//     if (!selectedId) return;
//     const el = elements.find((e) => e.id === selectedId);
//     if (!el) return;
//     setFontFamily(el.fontFamily || "Arimo");
//     setFontSize(el.fontSize || 24);
//     setFontColor(el.color || "#111111");
//     setIsBold(!!el.bold);
//     setIsItalic(!!el.italic);
//     setTextAlign(el.align || "left");
//   }, [selectedId]); // eslint-disable-line

//   const addTextField = () => {
//     const id = "el_" + Date.now();
//     const newEl = {
//       id,
//       type: "text",
//       text: "New Text",
//       x: 12,
//       y: 12,
//       width: 60, // px (will be scaled)
//       height: 18,
//       rotation: 0,
//       fontFamily: "Arimo",
//       fontSize: 24,
//       color: "#111111",
//       bold: false,
//       italic: false,
//       align: "left",
//     };
//     setElements((s) => [...s, newEl]);
//     setSelectedId(id);
//   };

//   const updateElement = (id, patch) => {
//     // console.log('this is id and patch', id, patch)
//     setElementsBack(prev => prev.map(p => p.id === id ? { ...p, ...patch } : p));
//     setElements((prev) => prev.map((p) => (p.id === id ? { ...p, ...patch } : p)));
//   };



//   const removeElement = (id) => {
//     setElements((prev) => prev.filter((p) => p.id !== id));
//     if (selectedId === id) setSelectedId(null);
//   };



//   const duplicateElement = (id, isBack = false) => {
//     const list = isBack ? elementsBack : elements;
//     const updater = isBack ? setElementsBack : setElements;

//     const el = list.find(e => e.id === id);
//     if (!el) return;

//     const copy = {
//       ...JSON.parse(JSON.stringify(el)),
//       id: "el_" + Date.now(),
//       x: el.x + 8,
//       y: el.y + 8,
//     };

//     updater(prev => [...prev, copy]);
//     setSelectedId(copy.id);
//   };


//   const rotateSelected = (id, degDelta = 15) => {
//     const el = elements.find((e) => e.id === id);
//     if (!el) return;
//     updateElement(id, { rotation: (el.rotation + degDelta) % 360 });
//   };

//   const applyToolbarToSelected = () => {
//     if (!selectedId) return;
//     updateElement(selectedId, {
//       fontFamily,
//       fontSize,
//       color: fontColor,
//       bold: isBold,
//       italic: isItalic,
//       align: textAlign,
//     });
//   };

//   useEffect(() => {
//     applyToolbarToSelected();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [fontFamily, fontSize, fontColor, isBold, isItalic, textAlign]);


//   const CARD_MM = { w: 88, h: 55 };




//   //============================
//   //=============================



//   // px per mm measurement
//   const [pxPerMm, setPxPerMm] = useState(3.78); // default fallback ~96 DPI -> 3.78 px/mm
//   const measureRef = useRef(null);

//   // card mm dimensions (user-visible and editable)
//   const [cardMm, setCardMm] = useState({ w: 88, h: 55 }); // mm
//   const [cardPos, setCardPos] = useState({ x: 40, y: 40 }); // px within A4 container
//   const [cardZoom, setCardZoom] = useState(1); // zoom only for card
//   const [cardBg, setCardBg] = useState("#ffffff"); // background color (transparent if null)
//   const [showCard, setShowCard] = useState(false);

//   // Back card

//   const [cardBgBack, setCardBgBack] = useState("#000000ff");

//   const [qrPos, setQrPos] = useState({ x: 40, y: 40 });
//   const [qrSizeWidth, setQrSizeWidth] = useState(120);
//   const [qrSizeHeight, setQrSizeHeight] = useState(120);


//   const [sidebarOpenPanel, setSidebarOpenPanel] = useState("text"); // "text" | "background" | other
//   const [sidebarOpenPanelBack, setSidebarOpenPanelBack] = useState("text");
//   const [expandedTextRows, setExpandedTextRows] = useState({}); // id:true/false
//   const a4Ref = useRef(null);
//   const cardRef = useRef(null);
//   const cardRefBack = useRef(null);
//   // sample uploaded logo path (developer-provided)
//   //const sampleLogoUrl = "/mnt/data/3fb6be9d-c971-4e00-b90f-b53691650458.png";

//   // measure px/mm on mount and on resize
//   useEffect(() => {
//     function measure() {
//       const el = document.createElement("div");
//       el.style.width = "100mm";
//       el.style.position = "absolute";
//       el.style.left = "-9999px";
//       document.body.appendChild(el);
//       const px = el.getBoundingClientRect().width;
//       document.body.removeChild(el);
//       if (px > 0) setPxPerMm(px / 100);
//     }
//     measure();
//     window.addEventListener("resize", measure);
//     return () => window.removeEventListener("resize", measure);
//   }, []);

//   // persist to sessionStorage
//   useEffect(() => {
//     const payload = {
//       cardMm, cardPos, cardBg, elements
//     };

//     // sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
//     sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));

//   }, [cardMm, cardPos, cardBg, elements, elementsBack]);

//   useEffect(() => {
//     const payload1 = {
//       cardMm, cardPos, cardBg, elementsBack
//     };
//     // sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
//     sessionStorage.setItem(STORAGE_KEY_BACK, JSON.stringify(payload1));

//   }, [cardMm, cardPos, cardBg, elements, elementsBack]);



//   useEffect(() => {
//     try {
//       const savedFront = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
//       const savedBack = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));
//       const savedMeta = JSON.parse(sessionStorage.getItem("CARD_META"));

//       if (Array.isArray(savedFront)) setElements(savedFront);
//       if (Array.isArray(savedBack)) setElementsBack(savedBack);

//       if (savedMeta?.cardMm) setCardMm(savedMeta.cardMm);
//       if (savedMeta?.cardPos) setCardPos(savedMeta.cardPos);
//       if (savedMeta?.cardBg !== undefined) setCardBg(savedMeta.cardBg);

//       setShowCard(
//         (Array.isArray(savedFront) && savedFront.length > 0) ||
//         (Array.isArray(savedBack) && savedBack.length > 0) ||
//         !!savedMeta?.cardMm || true
//       );
//     } catch {
//       // ignore errors
//     }
//   }, []);


//   // helpers: add text
//   const addText = () => {
//     const id = "t_" + Date.now();
//     const defaultPxW = 80;
//     // console.log('this is defaultPxW', defaultPxW)
//     const defaultPxH = 30;
//     const newT = {
//       id,
//       type: "text",
//       text: "New Text",
//       // x: Math.round((cardMm.w * pxPerMm - defaultPxW) / 2),
//       // y: Math.round((cardMm.h * pxPerMm - defaultPxH) / 2),

//       x: Math.round(defaultPxW),
//       y: Math.round(defaultPxH),

//       width: defaultPxW,
//       height: defaultPxH,
//       fontFamily: "Arimo",
//       fontSize: 16,
//       color: "#111111",
//       bold: false,
//       italic: false,
//       align: "left",
//       rotation: 0,
//     };
//     setElements(prev => [...prev, newT]);
//     setExpandedTextRows(prev => ({ ...prev, [id]: true }));
//     setSelectedId(id);
//     setShowCard(true);
//   };

//   const addTextBack = () => {
//     const id = "t_" + Date.now();
//     const defaultPxW = 80;
//     const defaultPxH = 30;
//     const newT = {
//       id,
//       type: "text",
//       text: "New Text",
//       x: Math.round(defaultPxW),
//       y: Math.round(defaultPxH),

//       width: defaultPxW,
//       height: defaultPxH,
//       fontFamily: "Arimo",
//       fontSize: 16,
//       color: "#111111",
//       bold: false,
//       italic: false,
//       align: "left",
//       rotation: 0,
//     };
//     setElementsBack(prev => [...prev, newT]);
//     setExpandedTextRows(prev => ({ ...prev, [id]: true }));
//     setSelectedId(id);
//     setShowCard(true);
//   };




//   const addImageElement = () => {
//     if (!selectedImagee) return;
//     // console.log("Selected image when Saving = ", selectedImagee);

//     const id = "i_" + Date.now(); // unique ID for image
//     const newImage = {
//       id,
//       type: "image",
//       src: selectedImagee,
//       shape: imageShape || "square",
//       objectFit: imageFit || "cover",
//       x: 20, // default position
//       y: 20,
//       width: 100,
//       height: 100,
//     };

//     setElements(prev => [...prev, newImage]);
//     setSelectedId(id); // select newly added image
//     setShowCard(true);
//     setShowImageModal(false);
//   };

//   const addImageElementBack = () => {
//     if (!selectedImageeBack) return;

//     const id = "i_" + Date.now(); // unique ID for image
//     const newImage = {
//       id,
//       type: "image",
//       src: selectedImageeBack,
//       shape: imageShape || "square",
//       objectFit: imageFit || "cover",
//       x: 20, // default position
//       y: 20,
//       width: 100,
//       height: 100,
//     };

//     setElementsBack(prev => [...prev, newImage]);
//     setSelectedId(id); // select newly added image
//     setShowCard(true);
//     setShowImageModal(false);
//   };


//   // const updateElement = (id, patch) => {
//   //   setElements(prev => prev.map(e => e.id === id ? { ...e, ...patch } : e));
//   // };
//   const deleteElement = (id) => {
//     setElements(prev => prev.filter(e => e.id !== id));
//     setElementsBack(prev => prev.filter(e => e.id !== id));
//     setSelectedId(s => s === id ? null : s);
//     setExpandedTextRows(prev => { const c = { ...prev }; delete c[id]; return c; });
//   };



//   const mmDisplay = `${cardMm.w.toFixed(2)} × ${cardMm.h.toFixed(2)} mm`;

//   // clicking on A4 outside card should deselect
//   const onA4MouseDown = (ev) => {
//     // if clicked directly on A4 background (not inside card), deselect
//     // check if click target is inside cardRef
//     if (!cardRef.current) {
//       setSelectedId(null);
//       return;
//     }
//     if (!cardRef.current.contains(ev.target)) {
//       setSelectedId(null);
//       // also collapse expanded rows? keep as-is
//     }
//   };

//   // when clicking background area inside card, open background panel
//   const onCardBackgroundClick = (ev) => {

//     let node = ev.target;
//     let foundEl = false;
//     while (node && node !== cardRef.current) {
//       if (node.dataset && node.dataset.elId) {
//         foundEl = true;
//         break;
//       }
//       node = node.parentNode;
//     }
//     if (!foundEl) {
//       setSidebarOpenPanel("background");
//       setSelectedId(null);
//     }
//   };

//   // card px dims derived from mm -> px
//   const cardPxW = Math.round(cardMm.w * pxPerMm);
//   const cardPxH = Math.round(cardMm.h * pxPerMm);

//   // helper to convert px -> mm for resize
//   const pxToMm = (px) => px / pxPerMm;
//   const mmToPx = (mm) => Math.round(mm * pxPerMm);

//   // available CMYK-ish swatches (approx hex equivalents)
//   const cmykSwatches = [
//     { name: "C 100 M 0 Y 0 K 0", hex: "#0085CA" },
//     { name: "M 100 C 0 Y 0 K 0", hex: "#E4007F" },
//     { name: "Y 100 C 0 M 0 K 0", hex: "#FFCC00" },
//     { name: "K 100 C 0 M 0 Y 0", hex: "#111111" },
//     { name: "C 50 M 0 Y 0 K 0", hex: "#4CAFEA" },

//     { name: "C 100 M 100 Y 0 K 0", hex: "#5B2D90" },
//     { name: "C 0 M 100 Y 100 K 0", hex: "#ED1C24" },
//     { name: "C 0 M 50 Y 100 K 0", hex: "#F7941D" },
//     { name: "C 75 M 0 Y 100 K 0", hex: "#39B54A" },
//     { name: "C 100 M 0 Y 100 K 0", hex: "#00A651" },

//     { name: "C 60 M 100 Y 0 K 0", hex: "#92278F" },
//     { name: "C 30 M 100 Y 0 K 0", hex: "#C127B0" },
//     { name: "C 0 M 100 Y 50 K 0", hex: "#EC008C" },
//     { name: "C 0 M 75 Y 100 K 0", hex: "#F15A24" },
//     { name: "C 0 M 25 Y 100 K 0", hex: "#FCEE21" },

//     { name: "C 100 M 50 Y 0 K 0", hex: "#0072BC" },
//     { name: "C 100 M 25 Y 0 K 0", hex: "#00AEEF" },
//     { name: "C 75 M 25 Y 0 K 0", hex: "#29ABE2" },
//     { name: "C 50 M 25 Y 0 K 0", hex: "#7ACCC8" },
//     { name: "C 25 M 0 Y 50 K 0", hex: "#8DC63F" },

//     { name: "C 0 M 0 Y 0 K 50", hex: "#808285" },
//     { name: "C 0 M 0 Y 0 K 75", hex: "#58595B" },
//     { name: "C 0 M 0 Y 0 K 25", hex: "#BFC0C2" },
//     { name: "C 20 M 20 Y 20 K 0", hex: "#D1D3D4" },
//     { name: "C 10 M 0 Y 0 K 0", hex: "#D6EFFC" },

//     { name: "C 0 M 10 Y 0 K 0", hex: "#F8D7E8" },
//     { name: "C 0 M 0 Y 10 K 0", hex: "#FFF9C4" },
//     { name: "C 15 M 0 Y 15 K 0", hex: "#E6F5E9" },
//     { name: "C 0 M 15 Y 15 K 0", hex: "#FDEBD0" },
//     { name: "C 40 M 0 Y 40 K 0", hex: "#A2D39C" },
//   ];


//   //======================================
//   //======================================

//   const [activeSide, setActiveSide] = useState("front");

//   const [showBoth, setShowBoth] = useState(false);


//   const [frontImage, setFrontImage] = useState(null);
//   const [backImage, setBackImage] = useState(null);






//   const frontCardRef = useRef(null);
//   const backCardRef = useRef(null);




//   const [imageUrls, setImageUrls] = useState([]);
//   const [selectedImage_card, setSelectedImage_card] = useState(null);
//   const [showModal_card, setShowModal_card] = useState(false);



//   const downloadCard = async (ref, filename) => {
//     const card = ref.current;
//     if (!card) return;

//     // hide borders
//     const rndBoxes = card.querySelectorAll(".rnd-box");
//     const guides = card.querySelectorAll(".card-guides");
//     rndBoxes.forEach(el => el.style.border = "none");
//     guides.forEach(el => el.style.display = "none");

//     const canvas = await html2canvas(card, { scale: 3 });

//     // restore UI
//     rndBoxes.forEach(el => el.style.border = "");
//     guides.forEach(el => el.style.display = "");

//     // convert to base64
//     const base64 = canvas.toDataURL("image/png");

//     // convert base64 → Blob
//     const blob = await fetch(base64).then(res => res.blob());

//     // convert Blob → File
//     const file = new File([blob], filename + ".png", { type: "image/png" });

//     // 1️⃣ Download locally
//     const link = document.createElement("a");
//     link.download = `${filename}.png`;
//     link.href = base64;
//     link.click();

//     // 2️⃣ Upload to backend
//     // const loggedUser = JSON.parse(sessionStorage.getItem("userData"));
//     const loggedUser = sessionStorage.getItem("email")
//     const formData = new FormData();

//     formData.append("email", loggedUser);
//     formData.append("file", file);

//     await axios.post("https://api.nfcdesignstudio.com/API/v1/uploadPng", formData, {
//       headers: { "Content-Type": "multipart/form-data" }
//     });

//     alert("PNG uploaded successfully");

//   };






//   useEffect(() => {
//     // const loggedUser = JSON.parse(sessionStorage.getItem("userData"));
//     const loggedUser = sessionStorage.getItem("email")
//     if (!loggedUser) return;

//     axios
//       .get(`https://api.nfcdesignstudio.com/API/v1/getPng/${loggedUser}`)
//       .then(res => {
//         setImageUrls(res.data); // array of { id, imageUrl, imageName }
//       })
//       .catch(err => console.log(err));
//   }, []);




//   const [backendTextList, setBackendTextList] = useState([]);

//   const backendData = {
//     name: cards.name,
//     designation: cards.designation,
//     companyName: cards.companyName,
//     phoneNumber: cards.phoneNumber,
//     email: cards.email,
//     address: cards.address,
//     website: cards.website,

//   };

//   const backendTextElements = Object.entries(backendData)
//     .filter(([key, value]) => value && value !== "") // only non-empty fields
//     .map(([key, value]) => ({
//       id: "txt_" + key,
//       type: "text",
//       text: value,
//       fontSize: 16,
//       color: "#000",
//       x: 50,
//       y: 50,
//       width: 180,
//       height: 40
//     }));

//   useEffect(() => {
//     setBackendTextList(backendTextElements); // store only in modal
//   }, [cards]);


//   const addBackendTextToCard = (element) => {
//     setElementsBack(prev => [...prev, { ...element }]);
//   };

//   const addfrontTextToCard = (element) => {
//     setElements(prev => [...prev, { ...element }]);
//   };


//   const openImageModal = (id, imgSrc) => {
//     setSelectedId(id);          // track element in card
//     setSelectedImagee(imgSrc);  // show the current image inside modal
//     setShowImageModal(true);
//   };

//   // in here card image downlode 
//   const frontRef = useRef(null);
//   const backRef = useRef(null);

//   const downloadImage = (canvas, fileName) => {
//     const link = document.createElement("a");
//     link.download = fileName + ".png";
//     link.href = canvas.toDataURL("image/png");
//     link.click();
//   };

//   const downloadBothCards = async () => {
//     if (frontRef.current) {
//       const canvas1 = await html2canvas(frontRef.current, {
//         scale: 4, // HIGH quality PNG
//       });
//       downloadImage(canvas1, "card_front");
//     }

//     if (backRef.current) {
//       const canvas2 = await html2canvas(backRef.current, {
//         scale: 4,
//       });
//       downloadImage(canvas2, "card_back");
//     }
//   };


//   // this is Profile page code 


//   const [profile, setProfile] = useState(null);
//   const [editMode, setEditMode] = useState(false);

//   const [name, setName] = useState("");
//   const [mobile, setMobile] = useState("");




//   useEffect(() => {
//     // const loggedUser = JSON.parse(sessionStorage.getItem("email"));
//     const loggedUser = sessionStorage.getItem("email")
//     console.log("Logged user:", loggedUser);

//     if (!loggedUser) return;

//     fetchProfile(loggedUser);
//   }, []);


//   const fetchProfile = async (email) => {
//     try {
//       const res = await axios.get("https://api.nfcdesignstudio.com/API/v1/api/profilee");

//       console.log("Response:", res.data);

//       const allUsers = res.data.data;  // because backend returns { message, data }

//       // 🔍 Filter correct user
//       const matchedUser = allUsers.find((u) => u.email === email);

//       if (!matchedUser) {
//         console.error("No matching user found");
//         return;
//       }

//       console.log("Matched User:", matchedUser);

//       // Set states
//       setProfile(matchedUser);
//       setName(matchedUser.username);
//       setMobile(matchedUser.mobile);

//     } catch (err) {
//       console.error("Error loading profile:", err);
//     }
//   };


//   const updateProfile = async () => {
//     try {
//       const res = await axios.put("https://api.nfcdesignstudio.com/API/v1/profile/update", {
//         email: profile.email,
//         username: name,
//         mobile,
//       });

//       alert("Profile Updated!");
//       setEditMode(false);

//       setProfile({
//         ...profile,
//         username: name,
//         mobile,
//       });
//     } catch (err) {
//       console.error("Update failed:", err);
//     }
//   };

//   // if (!profile) return <h2 style={{textAlign:"center"}}>Loading...</h2>;
//   const styles = {
//     page: {
//       width: "90%",
//       maxWidth: "600px",
//       margin: "20px auto",
//       fontFamily: "Poppins",
//     },
//     card: {
//       background: "#fff",
//       padding: "25px",
//       borderRadius: "14px",
//       boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
//     },
//     row: {
//       marginBottom: "18px",
//     },
//     input: {
//       width: "100%",
//       padding: "10px",
//       border: "1px solid #ddd",
//       borderRadius: "8px",
//       fontSize: "15px",
//     },
//     btn: {
//       width: "100%",
//       padding: "12px",
//       background: "#0158a2",
//       color: "#fff",
//       border: "none",
//       borderRadius: "10px",
//       cursor: "pointer",
//       fontSize: "16px",
//       fontWeight: "600",
//     },
//     btnSave: {
//       width: "100%",
//       padding: "12px",
//       background: "#27ae60",
//       color: "#fff",
//       border: "none",
//       borderRadius: "10px",
//       cursor: "pointer",
//       fontSize: "16px",
//       fontWeight: "600",
//     },
//   };

//   const navigate = useNavigate();

//   const handleLogout = () => {
//     const confirmLogout = window.confirm("Are you sure you want to logout?");

//     if (confirmLogout) {
//       sessionStorage.clear();   // clear session storage
//       sessionStorage.removeItem("email"); // optional if needed
//       window.location.href = "/";  // redirect to home/login
//     }
//   };



//   return (


//     <>

//       <div style={{ flexShrink: 0, borderBottom: '1px solid #ccc', background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(10px)', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
//         <div>
//           <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>Digital Card Builder</h2>
//           <p style={{ fontSize: 14, color: '#555', margin: 0 }}>Create your professional NFC business card</p>
//         </div>

//         {/* Links */}
//         <div style={{ display: 'flex', gap: '16px' }}>
//           <Link to="/builder" style={{ textDecoration: "none", color: "#007bff", fontWeight: "500" }}>MY Card</Link>
//           <a href="/vfc-card" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }} > VFC Card</a>
//           <a href="/profile" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }}> Profile</a>
//           <a onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "6px", textDecoration: "none", color: "#007bff", fontWeight: "500", cursor: "pointer" }}><LogOut size={16} /> Logout</a>
//         </div>
//       </div>




//       <div style={{ height: "90vh", display: "flex", fontFamily: "Inter, Arial, sans-serif" }}>
//         <style>{`
//                 /* --------- Layout --------- */
//                 .vfc-sidebar {
//                   width: 260px;
//                   background: #fff;
//                   border-right: 1px solid #e6e6e6;
//                   padding: 16px;
//                   box-sizing: border-box;
//                 }
//                 .vfc-sidebar .group {
//                   padding: 8px 0;
//                 }
//                 .vfc-sidebar .item {
//                   display:flex;
//                   gap:12px;
//                   align-items:center;
//                   padding:10px;
//                   border-radius:8px;
//                   cursor:pointer;
//                   color:#222;
//                   margin-bottom:6px;
//                 }
//                 .vfc-sidebar .item:hover { background:#f3f9ff; }

//                 .vfc-main {
//                   flex:1;
//                   display:flex;
//                   flex-direction:column;
//                   gap:12px;
//                   padding: 14px;
//                   box-sizing:border-box;
//                   background: #f3f4f6;
//                 }

//                 .vfc-toolbar {
//                   background:white;
//                   padding:10px 12px;
//                   border-radius:10px;
//                   display:flex;
//                   gap:8px;
//                   align-items:center;
//                   box-shadow: 0 1px 0 rgba(0,0,0,0.03);
//                 }
//                 .vfc-toolbar select, .vfc-toolbar input[type="number"], .vfc-toolbar button, .vfc-toolbar input[type="color"] {
//                   border:1px solid #d7d7d7;
//                   padding:6px 8px;
//                   border-radius:8px;
//                   background:white;
//                 }
//                 .vfc-toolbar .tool-btn { display:inline-flex; align-items:center; justify-content:center; padding:6px; width:36px; height:36px; border-radius:8px; cursor:pointer; background:white; border:1px solid #eee; }
//                 .vfc-workarea {
//                   display:flex;
//                   align-items:flex-start;
//                   gap:12px;
//                 }

//                 /* A4 page centered and sized */
//                 .vfc-a4 {
//                   width:210mm;
//                   height:297mm;
//                   background: #ffffff;
//                   margin: 12px auto;
//                   box-shadow: 0 6px 20px rgba(0,0,0,0.12);
//                   display:flex;
//                   justify-content:center;
//                   align-items:center;
//                   position:relative;
//                 }
//                 .vfc-a4 .a4-inner {
//                   width: 100%;
//                   height: 100%;
//                   padding: 18mm 12mm; /* some inner margin to mimic viewport */
//                   box-sizing:border-box;
//                 }

//                 /* Card container: exact mm */
//                 .card-frame {
//                   width: 88mm;
//                   height: 55mm;
//                   background: #fff;
//                   border-radius: 10px;
//                   box-shadow: 0 2px 8px rgba(0,0,0,0.06);
//                   position: relative;
//                   overflow: visible;
//                   display:flex;
//                   justify-content:center;
//                   align-items:center;
//                 }
//                 /* Bleed and safety guides */
//                 .card-bleed {
//                   position:absolute;
//                   inset:0;
//                   pointer-events:none;
//                   border-radius:10px;
//                 }
//                 .bleed-line {
//                   position:absolute;
//                   inset:0;
//                   border: 1px solid rgba(0,120,210,0.08);
//                   border-radius:10px;
//                 }
//                 .safe-area {
//                   position:absolute;
//                   left: 6mm; top: 6mm; right: 6mm; bottom: 6mm;
//                   border: 1px dashed rgba(0,160,120,0.25);
//                   border-radius:8px;
//                   pointer-events:none;
//                 }

//                 /* elements placed on card */
//                 .card-elements {
//                   position:absolute;
//                   inset:0;
//                   pointer-events:none;
//                 }

//                 /* selected element overlay (icons) */
//                 .elm-overlay {
//                   position:absolute;
//                   pointer-events:auto;
//                 }
//                 .elm-controls {
//                   display:flex;
//                   gap:6px;
//                   position:absolute;
//                   transform: translate(-50%, 8px);
//                   left:50%;
//                 }

//                 /* sidebar text list */
//                 .text-list {
//                   margin-top:18px;
//                   background:#fbfdff;
//                   padding:10px;
//                   border-radius:8px;
//                   border:1px solid #f0f6ff;
//                 }
//                 .text-row {
//                   display:flex;
//                   justify-content:space-between;
//                   align-items:center;
//                   padding:6px 8px;
//                   border-bottom:1px solid #f1f1f1;
//                 }
//                 .text-row:last-child { border-bottom:none; }

//                 /* right preview */
//                 .vfc-right {
//                   width:220px;
//                   padding:12px;
//                 }
//                 .mini {
//                   background:white;
//                   height:100px;
//                   border-radius:8px;
//                   border:1px solid #e6e6e6;
//                   margin-bottom:8px;
//                   display:flex;
//                   align-items:center;
//                   justify-content:center;
//                 }

//                 /* small helpers */
//                 .small-btn {
//                   border:1px solid #e7e7e7;
//                   padding:6px 8px;
//                   border-radius:6px;
//                   cursor:pointer;
//                   background:white;
//                 }
//                 .selected-label {
//                   font-size:12px; color:#666; margin-left:8px;
//                 }

//                 /* Rnd inner text style */
//                 .rnd-text {
//                   display:inline-block;
//                   pointer-events:auto;
//                   user-select:none;
//                   padding:4px 6px;
//                 }
//                 .rnd-input {
//                   width:100%;
//                   height:100%;
//                   box-sizing:border-box;
//                 }

//                 /* responsive */
//                 @media (max-width:1200px) {
//                   .vfc-sidebar { display:none; }
//                 }

//                         .vfc-left {
//                   width: 260px; background: #fff; border-right:1px solid #eee; padding:12px; box-sizing:border-box;
//                 }
//                 .vfc-left .item { display:flex; gap:10px; align-items:center; padding:8px; cursor:pointer; border-radius:8px; }
//                 .vfc-left .item:hover { background:#f3f9ff; }

//                 .vfc-main { flex:1; background:#f3f4f6; padding:12px; box-sizing:border-box; display:flex; flex-direction:column; gap:12px; }
//                 .vfc-topbar { background:white; padding:10px; border-radius:8px; display:flex; align-items:center; gap:8px; }
//                 .vfc-topbar .small { padding:6px 8px; border:1px solid #e6e6e6; border-radius:8px; background:white; cursor:pointer; }
//                 .vfc-main .work { display:flex; gap:12px; align-items:flex-start; }

//                 .vfc-a4 {
//                   width:260mm; height:180mm; background:white; border-radios:'10px',box-shadow:0 6px 20px rgba(0,0,0,0.12); margin:auto; position:relative; display:flex; justify-content:center; align-items:center;
//                 }        

//                 .card-wrapper {position: absolute;
//           left: 50px;
//           top: 60px; transform-origin: top left; }
//                  .card-wrapper_back { position: absolute;
//           right: 50px;
//           top: 60px;
//           transform-origin: top right; }
//                 .card-node {
//                   width:${cardMm.w}mm; height:${cardMm.h}mm; border-radius:9px; position:relative; box-shadow:0 2px 10px rgba(0,0,0,0.08); overflow:visible;
//                   display:block;
//                 }
//                 .card-guides .bleed { position:absolute; inset:0; border-radius:9px; pointer-events:none; }
//                 .card-guides .bleed-line { border:1px solid rgba(0, 0, 0, 0.54); position:absolute; inset:0; border-radius:9px; }
//                 .card-guides .safe { position:absolute; left:6mm; right:6mm; top:6mm; bottom:6mm; border-radius:6px; border:1px dashed rgba(0, 160, 120, 0.52); pointer-events:none; }
//                 .card-elements { position:absolute; inset:0; pointer-events:auto; }

//                 .text-row { display:flex; justify-content:space-between; align-items:center; padding:6px 8px; border-bottom:1px solid #f1f1f1; }
//                 .text-row .controls { display:flex; gap:6px; align-items:center; }

//                 .right-panel { width:220px; padding:12px; box-sizing:border-box; background:#fff; border-left:1px solid #eee; }

//                 .mini { height:100px; border:1px solid #eee; border-radius:6px; display:flex; align-items:center; justify-content:center; margin-bottom:8px; background:#fafafa; }

//                 .rnd-box { border:1px solid rgba(255, 0, 0, 0.54); }
//               `}</style>

//         {/* Left Sidebar */}
















//         <div className="vfc-left">
//           <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
//             <div style={{ fontWeight: 700 }}>My Projects</div>
//             <div style={{ color: "#777", fontSize: 12 }}>NFC Visiting Cards</div>
//           </div>

//           <div style={{ marginBottom: 10 }}>
//             <div
//               className="item"
//               onClick={() => {
//                 if (activeSide === "front") {
//                   setShowTextModal(true);
//                 } else {
//                   setShowTextModalBack(true);
//                 }
//               }}
//             >
//               <FaTextHeight /> Text
//             </div>
//             <div
//               className="item"
//               onClick={() => {
//                 if (activeSide === "front") {
//                   setShowImageModal(true);
//                 } else {
//                   setShowImageModalBack(true);
//                 }
//               }}
//             >
//               <FaUpload /> Background Image
//             </div>
//             {/* <div className="item"><FaShapes /> Graphics</div>  setShowImageModalBack*/}
//             {/* <div className="item" onClick={() => setSidebarOpenPanel(true)}><FaImage /> Background</div> */}
//             <div className="item" onClick={() => { if (activeSide === "front") { setSidebarOpenPanel(true); } else { setSidebarOpenPanelBack(true); } }}>
//               <FaImage /> Background Color
//             </div>

//             {/* <div className="item"><FaBorderAll /> Template</div> */}
//             {/* <div className="item"><FaQrcode /> QR-codes</div> */}
//             {/* <div className="item"><FaTable /> Tables</div> */}
//           </div>


//           {/* Background controls panel when selected */}




//           {sidebarOpenPanel && (
//             <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", justifyContent: "flex-end", zIndex: 2000 }}>
//               {/* Sidebar Panel */}
//               <div style={{ width: "100%", maxWidth: "400px", height: "100%", background: "#ffffff", padding: "20px", boxShadow: "-4px 0 15px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", overflowY: "auto" }}>
//                 {/* Header */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//                   <div>
//                     <div style={{ fontSize: "16px", fontWeight: 600 }}>Background Colour Picker Settings</div>
//                     <div style={{ fontSize: "12px", color: "#6b7280" }}>{cardMm.w} × {cardMm.h} mm</div>
//                   </div>
//                   <button onClick={() => setSidebarOpenPanel(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>✕</button>
//                 </div>

//                 {/* Color Picker Card */}
//                 <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", marginBottom: "20px", border: "1px solid #e5e7eb" }}>
//                   <div style={{ fontSize: "14px", marginBottom: "10px", fontWeight: 500 }}>Pick Color</div>
//                   <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                     <input type="color" value={cardBg ?? "#ffffff"} onChange={(ev) => setCardBg(ev.target.value)} style={{ width: "50px", height: "40px", border: "none", cursor: "pointer" }} />
//                     <button onClick={() => setCardBg(null)} style={{ background: "#f3f4f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}>Remove</button>
//                   </div>
//                 </div>

//                 {/* CMYK Swatches */}
//                 <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", border: "1px solid #e5e7eb" }}>
//                   <div style={{ fontSize: "14px", marginBottom: "12px", fontWeight: 500 }}>CMYK Swatches</div>

//                   <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(40px, 1fr))", gap: "10px" }}>
//                     {cmykSwatches.map(s => (
//                       <div key={s.hex} onClick={() => setCardBg(s.hex)} title={s.name} style={{ width: "100%", aspectRatio: "1 / 1", background: s.hex, borderRadius: "8px", cursor: "pointer", border: cardBg === s.hex ? "3px solid #2563eb" : "1px solid #e5e7eb", transition: "0.2s" }} />
//                     ))}
//                   </div>
//                 </div>

//                 {/* Footer */}
//                 <div style={{ marginTop: "auto", paddingTop: "20px" }}>
//                   <button onClick={() => setSidebarOpenPanel(false)} style={{ width: "100%", background: "#2563eb", color: "#fff", border: "none", padding: "10px", borderRadius: "10px", cursor: "pointer", fontWeight: 500 }}>Done</button>
//                 </div>
//               </div>
//             </div>
//           )}

//           <Modal isOpen={showTextModal} onRequestClose={() => setShowTextModal(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000 }, content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", width: "90%", maxWidth: "1000px", maxHeight: "90vh", overflowY: "auto", padding: "20px", borderRadius: "16px", border: "none" } }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
//               <h5 style={{ margin: 0 }}>EDIT TEXT</h5>
//               <button onClick={() => setShowTextModal(false)} title="Close" style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}><FaTimes /></button>
//             </div>
//             <div className="section-card">
//               <label className="section-title">All Text Elements</label>
//               <div className="text-list">
//                 {elements.filter(el => el.type === "text").map(el => (
//                   <div key={el.id} className={`text-list-item ${selectedId === el.id ? "active" : ""}`} onClick={() => setSelectedId(el.id)}>
//                     <span className="text-preview">{el.text}</span>
//                     <span className="text-size-badge">{Math.round(el.fontSize)}px</span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="section-card">
//               <label className="section-title">Available Backend Fields</label>
//               <div className="text-list">
//                 {backendTextList.map(el => (
//                   <div key={el.id} className="text-list-item" onClick={() => addfrontTextToCard(el)}>
//                     <span className="text-preview">{el.text}</span>
//                     <span className="text-size-badge"><FaPlus /></span>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* TEXT PROPERTIES SECTION */}
//             {selectedId && (
//               <div className="section-card">
//                 <label className="section-title">Formatting</label>
//                 <label className="input-label">Font Size</label>
//                 <input type="number" className="input-field" value={fontSize} onChange={e => setFontSize(Number(e.target.value))} />
//                 <label className="input-label">Font Family</label>
//                 <select className="dropdown" value={fontFamily} onChange={e => setFontFamily(e.target.value)} >
//                   <option>Arimo</option>
//                   <option>Poppins</option>
//                   <option>Roboto</option>
//                   <option>Inter</option>
//                 </select>
//                 <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//                   <button onClick={() => setIsBold(!isBold)} title="Bold" style={{ background: isBold ? "#2563eb" : "#f3f4f6", color: isBold ? "#fff" : "#000", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}><FaBold /></button>
//                   <button onClick={() => setIsItalic(!isItalic)} title="Italic" style={{ background: isItalic ? "#2563eb" : "#f3f4f6", color: isItalic ? "#fff" : "#000", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}><FaItalic /></button>
//                 </div>
//               </div>
//             )}

//             <div style={{ background: "#ffffff", borderRadius: "12px", padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", marginTop: "15px" }}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "10px" }}>
//                 <strong style={{ fontSize: "16px" }}>Text Elements</strong>
//                 <button onClick={addText} title="Add Text" style={{ background: "#2563eb", color: "#fff", border: "none", padding: "8px 10px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaPlus /></button>
//               </div>
//               {elements.filter(e => e.type === "text").length === 0 && (
//                 <div style={{ textAlign: "center", padding: "20px", background: "#f9fafb", borderRadius: "10px", color: "#6b7280", fontSize: "14px" }}>
//                   No text yet
//                   <div style={{ marginTop: "8px" }}>Click <FaPlus style={{ verticalAlign: "middle" }} /> to add text</div>
//                 </div>
//               )}
//               {elements.filter(e => e.type === "text").map(el => (
//                 <div key={el.id} style={{ background: selectedId === el.id ? "#eff6ff" : "#f9fafb", border: selectedId === el.id ? "1px solid #2563eb" : "1px solid #e5e7eb", borderRadius: "10px", padding: "12px", marginBottom: "10px", transition: "0.2s", display: "flex", flexDirection: "column", gap: "10px" }}>
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
//                     <div style={{ flex: 1, minWidth: "120px" }}>
//                       <div style={{ fontWeight: 500, fontSize: "14px", wordBreak: "break-word" }}>{el.text}</div>
//                       <div style={{ fontSize: "12px", color: "#6b7280" }}>{Math.round(el.fontSize)}px</div>
//                     </div>
//                     <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
//                       <button onClick={() => { setExpandedTextRows(prev => ({ ...prev, [el.id]: !prev[el.id] })); setSelectedId(el.id); }} title="Expand" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaChevronDown /></button>
//                       <button onClick={() => setSelectedId(el.id)} title="Select" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✓</button>
//                       <button onClick={() => duplicateElement(el.id)} title="Duplicate" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaClone /></button>
//                       <button onClick={() => deleteElement(el.id)} title="Delete" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626" }}><FaTrash /></button>
//                     </div>
//                   </div>

//                   {/* Expand Section */}
//                   {expandedTextRows[el.id] && (
//                     <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "6px" }}>
//                       <input value={el.text} onChange={(ev) => updateElement(el.id, { text: ev.target.value })} style={{ padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }} />
//                       <input type="color" value={el.color} onChange={(ev) => updateElement(el.id, { color: ev.target.value })} style={{ width: "50px", height: "35px", border: "none", cursor: "pointer" }} />
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//             <div style={{ marginTop: "15px", textAlign: "right" }}>
//               <button onClick={() => setShowTextModal(false)} style={{ background: "#16a34a", color: "#fff", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px" }}><FaCheck />Done</button>
//             </div>
//           </Modal>


//           <Modal isOpen={showImageModal} onRequestClose={() => setShowImageModal(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000 }, content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", width: "90%", maxWidth: "1000px", maxHeight: "90vh", overflowY: "auto", padding: "20px", borderRadius: "16px", border: "none" } }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//               <h5 style={{ margin: 0 }}>Select Image</h5>
//               <button onClick={() => setShowImageModal(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}><FaTimes /></button>
//             </div>
//             <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
//               <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Upload New Image</label>
//               <div style={{ border: "2px dashed #d1d5db", borderRadius: "12px", padding: "25px", textAlign: "center", background: "#f9fafb" }}>
//                 <input type="file" accept="image/*" style={{ marginBottom: "10px" }}
//                   onChange={e => {
//                     const file = e.target.files?.[0];
//                     if (!file) return;
//                     const reader = new FileReader();
//                     reader.onload = () => {
//                       const base64 = reader.result;
//                       setSelectedImagee(base64);
//                       setCards(prev => ({
//                         ...prev,
//                         images: [...prev.images, base64]
//                       }));
//                     };
//                     reader.readAsDataURL(file);
//                   }}
//                 />
//                 <div style={{ color: "#6b7280", fontSize: "13px" }}>Drag & drop or choose image</div>
//               </div>
//             </div>
//             <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "15px", marginTop: "15px" }}>
//               {/* Shape */}
//               <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
//                 <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Shape</label>
//                 <select value={imageShape} onChange={e => setImageShape(e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }}>
//                   <option value="square">Square</option>
//                   <option value="rounded">Rounded</option>
//                   <option value="circle">Circle</option>
//                 </select>
//               </div>

//               {/* Object Fit */}
//               <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
//                 <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Object Fit</label>
//                 <select value={imageFit} onChange={e => setImageFit(e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }}>
//                   <option>cover</option>
//                   <option>contain</option>
//                   <option>fill</option>
//                   <option>none</option>
//                   <option>scale-down</option>
//                 </select>
//               </div>
//             </div>

//             {/* Footer */}
//             <div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap" }}>
//               <button onClick={() => setShowImageModal(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer" }}>Cancel</button>
//               <button onClick={addImageElement} style={{ background: "#2563eb", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}><FaCheck />Save</button>
//             </div>
//           </Modal>



//           {/* <Modal
//                       isOpen={showImageModal}
//                       onRequestClose={() => setShowImageModal(false)}
//                       className="rich-modal"
//                       overlayClassName="rich-overlay"
//                     >
//                       <div className="modal-header">
//                         <h2>Edit Image</h2>
//                         <button className="close-btn" onClick={() => setShowImageModal(false)}>✕</button>
//                       </div>


//                       {selectedId && elements.find(e => e.id === selectedId && e.type === "image") && (
//                         <div className="section-card">
//                           <label className="section-title">Selected Image</label>
//                           <div className="image-selected-preview">
//                             <img
//                               src={selectedImagee}
//                               className="preview-image"
//                               style={{ maxHeight: "120px" }}
//                             />
//                           </div>

//                           <button
//                             className="btn danger-btn"
//                             onClick={() => {
//                               deleteElement(selectedId);  // remove image from card
//                               setSelectedImagee(null);
//                             }}
//                           >
//                             Remove Image
//                           </button>
//                         </div>
//                       )}


//                       <div className="section-card">
//                         <label className="section-title">Upload New Image</label>

//                         <input
//                           type="file"
//                           accept="image/*"
//                           className="file-input"
//                           onChange={e => {
//                             const file = e.target.files?.[0];
//                             if (!file) return;

//                             const reader = new FileReader();
//                             reader.onload = () => {
//                               const base64 = reader.result;

//                               // Add to image list
//                               setCards(prev => ({
//                                 ...prev,
//                                 images: [...prev.images, base64]
//                               }));

//                               // update preview
//                               setSelectedImagee(base64);
//                             };

//                             reader.readAsDataURL(file);
//                           }}
//                         />
//                       </div>


//                       <div className="section-card">
//                         <label className="section-title">Images In Card</label>

//                         <div className="image-grid-new">
//                           {cards.images.map((img, i) => (
//                             <div
//                               key={i}
//                               className={`image-select-box ${selectedImagee === img ? "active" : ""}`}
//                               onClick={() => setSelectedImagee(img)}
//                             >
//                               <img src={img} className="preview-image" />
//                             </div>
//                           ))}
//                         </div>
//                       </div>

//                       <div className="section-card">
//                         <label className="section-title">Shape</label>
//                         <select className="dropdown" value={imageShape} onChange={e => setImageShape(e.target.value)}>
//                           <option value="square">Square</option>
//                           <option value="rounded">Rounded</option>
//                           <option value="circle">Circle</option>
//                         </select>
//                       </div>


//                       <div className="section-card">
//                         <label className="section-title">Object Fit</label>
//                         <select className="dropdown" value={imageFit} onChange={e => setImageFit(e.target.value)}>
//                           <option>cover</option>
//                           <option>contain</option>
//                           <option>fill</option>
//                           <option>none</option>
//                           <option>scale-down</option>
//                         </select>
//                       </div>


//                       <div className="modal-footer">

//                          <button
//                           className="btn primary-btn"
//                           onClick={addImageElement}
//                         >
//                           Save
//                         </button>

//                         <button className="btn cancel-btn" onClick={() => setShowImageModal(false)}>
//                           Cancel
//                         </button>
//                       </div>
//                     </Modal> */}

//           {/************** Back card */}


//           <Modal isOpen={sidebarOpenPanelBack} onRequestClose={() => setSidebarOpenPanelBack(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.4)", zIndex: 1000 }, content: { top: 0, right: 0, left: "auto", bottom: 0, width: "100%", maxWidth: "420px", height: "100vh", padding: "20px", borderRadius: "0px", border: "none", overflowY: "auto", boxShadow: "-6px 0 20px rgba(0,0,0,0.1)" } }}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
//               <div>
//                 <div style={{ fontSize: "16px", fontWeight: 600 }}>Back Card Background</div>
//                 <div style={{ fontSize: "12px", color: "#6b7280" }}>{cardMm.w} × {cardMm.h} mm</div>
//               </div>
//               <button onClick={() => setSidebarOpenPanelBack(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>✕</button>
//             </div>
//             <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", marginBottom: "20px", border: "1px solid #e5e7eb" }}>
//               <div style={{ fontSize: "14px", marginBottom: "10px", fontWeight: 500 }}>Pick Custom Color</div>
//               <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                 <input type="color" value={cardBgBack ?? "#ffffff"} onChange={(ev) => setCardBgBack(ev.target.value)} style={{ width: "55px", height: "40px", border: "none", cursor: "pointer" }} />
//                 <button onClick={() => setCardBgBack(null)} style={{ background: "#f3f4f6", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer" }}>Remove Color</button>
//               </div>
//             </div>
//             <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", border: "1px solid #e5e7eb" }}>
//               <div style={{ fontSize: "14px", marginBottom: "12px", fontWeight: 500 }}>CMYK Swatches</div>
//               <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(42px, 1fr))", gap: "10px" }}>
//                 {cmykSwatches.map(s => (
//                   <div key={s.hex} onClick={() => setCardBgBack(s.hex)} title={s.name} style={{ width: "100%", aspectRatio: "1 / 1", background: s.hex, borderRadius: "8px", cursor: "pointer", border: cardBgBack === s.hex ? "3px solid #2563eb" : "1px solid #e5e7eb", transition: "0.2s" }} />
//                 ))}
//               </div>
//             </div>
//             <div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
//               <button onClick={() => setSidebarOpenPanelBack(false)} style={{ background: "#2563eb", color: "#fff", border: "none", padding: "10px 18px", borderRadius: "10px", cursor: "pointer", fontWeight: 500 }}>Done</button>
//             </div>
//           </Modal>




//           < Modal
//             isOpen={showTextModalBack}
//             onRequestClose={() => setShowTextModalBack(false)}
//             className="rich-modal"
//             overlayClassName="rich-overlay"
//           >

//             {/* Modal Header */}
//             < div className="modal-header" >
//               <h2>Back Card Text</h2>
//               <button className="close-btn" onClick={() => setShowTextModalBack(false)}>✕</button>
//             </div >

//             {/* TEXT LIST SECTION */}
//             < div className="section-card" >
//               <label className="section-title">All Text Elements</label>

//               <div className="text-list">
//                 {elementsBack
//                   .filter(el => el.type === "text")
//                   .map(el => (
//                     <div
//                       key={el.id}
//                       className={`text-list-item ${selectedId === el.id ? "active" : ""}`}
//                       onClick={() => setSelectedId(el.id)}
//                     >
//                       <span className="text-preview">{el.text}</span>
//                       <span className="text-size-badge">{Math.round(el.fontSize)}px</span>
//                     </div>
//                   ))}
//               </div>
//             </div >

//             <div className="section-card">
//               <label className="section-title">Available Backend Fields</label>

//               <div className="text-list">
//                 {backendTextList.map(el => (
//                   <div
//                     key={el.id}
//                     className="text-list-item"
//                     onClick={() => addBackendTextToCard(el)}
//                   >
//                     <span className="text-preview">{el.text}</span>
//                     <span className="text-size-badge">Add</span>
//                   </div>
//                 ))}
//               </div>
//             </div>


//             {/* TEXT PROPERTIES SECTION */}
//             {
//               selectedId && (
//                 <div className="section-card">
//                   <label className="section-title">Formatting</label>

//                   <label className="input-label">Font Size</label>
//                   <input
//                     type="number"
//                     className="input-field"
//                     value={fontSize}
//                     onChange={e => setFontSize(Number(e.target.value))}
//                   />

//                   <label className="input-label">Font Color</label>
//                   <input
//                     type="color"
//                     className="color-field"
//                     value={fontColor}
//                     onChange={e => setFontColor(e.target.value)}
//                   />

//                   <label className="input-label">Font Family</label>
//                   <select
//                     className="dropdown"
//                     value={fontFamily}
//                     onChange={e => setFontFamily(e.target.value)}
//                   >
//                     <option>Arimo</option>
//                     <option>Poppins</option>
//                     <option>Roboto</option>
//                     <option>Inter</option>
//                   </select>

//                   <div className="row-buttons">
//                     <button className="btn toggle-btn" onClick={() => setIsBold(!isBold)}>
//                       {isBold ? "Unbold" : "Bold"}
//                     </button>
//                     <button className="btn toggle-btn" onClick={() => setIsItalic(!isItalic)}>
//                       {isItalic ? "Unitalic" : "Italic"}
//                     </button>
//                   </div>
//                 </div>
//               )
//             }

//             {/* TEXT MANAGEMENT LIST (Your big block preserved 1:1) */}
//             <div className="section-card">
//               <div className="panel-header">
//                 <strong>Text</strong>
//                 <button className="btn small-btn" onClick={addTextBack}>+ Add</button>
//               </div>

//               {elementsBack.filter(e => e.type === "text").length === 0 && (
//                 <div className="empty-info">No text yet — click Add</div>
//               )}

//               {elementsBack.filter(e => e.type === "text").map(el => (
//                 <div
//                   key={el.id}
//                   className={`text-row2 ${selectedId === el.id ? "active-row" : ""}`}
//                 >
//                   <div className="left-info">
//                     <div className="text-main">{el.text}</div>
//                     <div className="text-size">{Math.round(el.fontSize)}px</div>
//                   </div>

//                   <div className="controls">
//                     <button
//                       className="btn small-btn"
//                       onClick={() => {
//                         setExpandedTextRows(prev => ({ ...prev, [el.id]: !prev[el.id] }));
//                         setSelectedId(el.id);
//                       }}
//                     >
//                       ▾
//                     </button>
//                     <button className="btn small-btn" onClick={() => setSelectedId(el.id)}>Select</button>
//                     <button className="btn small-btn" onClick={() => duplicateElement(el.id)}>
//                       <FaClone />
//                     </button>
//                     <button className="btn small-btn danger-btn" onClick={() => deleteElement(el.id)}>
//                       <FaTrash />
//                     </button>
//                   </div>

//                   {expandedTextRows[el.id] && (
//                     <div className="expand-area">
//                       <input
//                         className="expand-input"
//                         value={el.text}
//                         onChange={(ev) => updateElement(el.id, { text: ev.target.value })}
//                       />
//                       <select
//                         className="expand-select"
//                         value={el.fontFamily}
//                         onChange={(ev) => updateElement(el.id, { fontFamily: ev.target.value })}
//                       >
//                         <option>Arimo</option>

//                         <option>Roboto</option>
//                         <option>Poppins</option>
//                         <option>Times New Roman</option>
//                       </select>
//                       <input
//                         type="color"
//                         className="color-field"
//                         value={el.color}
//                         onChange={(ev) => updateElement(el.id, { color: ev.target.value })}
//                       />
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* FOOTER */}
//             <div className="modal-footer">
//               <button className="btn primary-btn" onClick={() => setShowTextModalBack(false)}>
//                 Done
//               </button>
//             </div>

//           </Modal >


//           <Modal
//             isOpen={showImageModalBack}
//             onRequestClose={() => setShowImageModalBack(false)}
//             className="rich-modal"
//             overlayClassName="rich-overlay"
//           >

//             <div className="modal-header">
//               <h2>Select Image</h2>
//               <button className="close-btn" onClick={() => setShowImageModalBack(false)}>✕</button>
//             </div>

//             {/* Upload */}
//             <div className="section-card">
//               <label className="section-title">Upload Back Card Image</label>
//               {/* <input
//                           type="file"
//                           accept="image/*"
//                           className="file-input"

//                           onChange={e => {
//                             const file = e.target.files?.[0];
//                             if (!file) return;

//                             const fileUrl = URL.createObjectURL(file);
//                             setSelectedImage(fileUrl);   // ← FIX: use same state as grid selection
//                           }}

//                         /> */}

//               <input
//                 type="file"
//                 accept="image/*"
//                 className="file-input"
//                 onChange={e => {
//                   const file = e.target.files?.[0];
//                   if (!file) return;

//                   const fileUrl = URL.createObjectURL(file);

//                   // Add uploaded image to cards.images so it shows in the grid
//                   setCards(prev => ({ ...prev, images: [...prev.images, fileUrl] }));

//                   // Select this image immediately
//                   setSelectedImageeBack(fileUrl);
//                 }}
//               />

//             </div>


//             {/* <div className="section-card">
//                         <label className="section-title">Your Card Images</label>

//                         <div className="image-grid-new">
//                           {cards.images.map((img, i) => (
//                             <div
//                               key={i}
//                               className={`image-select-box ${selectedImageeBack === img ? "active" : ""}`}
//                               onClick={() => setSelectedImageeBack(img)} // ← use selectedImagee consistently
//                             >
//                               <img src={img} className="preview-image" />
//                             </div>
//                           ))}
//                           <div
//                             className={`image-select-box ${selectedImageeBack === cards.image ? "active" : ""}`}
//                             onClick={() => setSelectedImageeBack(cards.image)}
//                           >
//                             <img src={cards.image} className="preview-image" />
//                           </div>

//                         </div>

//                       </div> */}


//             {/* Shape */}
//             <div className="section-card">
//               <label className="section-title">Shape</label>
//               <select className="dropdown" value={imageShape} onChange={e => setImageShape(e.target.value)}>
//                 <option value="square">Square</option>
//                 <option value="rounded">Rounded</option>
//                 <option value="circle">Circle</option>
//               </select>
//             </div>

//             {/* Object Fit */}
//             <div className="section-card">
//               <label className="section-title">Object Fit</label>
//               <select className="dropdown" value={imageFit} onChange={e => setImageFit(e.target.value)}>
//                 <option>cover</option>
//                 <option>contain</option>
//                 <option>fill</option>
//                 <option>none</option>
//                 <option>scale-down</option>
//               </select>
//             </div>

//             {/* Footer */}
//             <div className="modal-footer">
//               <button className="btn primary-btn" onClick={addImageElementBack} title="Save"> <FaSave /></button>
//               <button className="btn cancel-btn" onClick={() => setShowImageModalBack(false)} title="Cancel"> <FaTimes /></button>
//             </div>
//           </Modal>
//         </div >







































//         {/* Main area */}
//         < div className="vfc-main" >
//           <div className="vfc-topbar">
//             <div style={{ fontWeight: 700 }}>Editor</div>
//             <div style={{ marginLeft: 12 }} className="small">Card: {mmDisplay}</div>
//             <div style={{ marginLeft: "auto", display: "flex", gap: 8, alignItems: "center" }}>
//               <button onClick={() => downloadCard(cardRef, "front-card")}>Download Front Card</button>
//               <button onClick={() => downloadCard(cardRefBack, "back-card")}>Download Back Card</button>
//               <button className="small" onClick={() => setCardZoom(z => Math.max(1, +(z - 0.1).toFixed(2)))}><FaMinus /></button>
//               <div style={{ minWidth: 40, textAlign: "center" }}>{Math.round(cardZoom * 83)}%</div>
//               <button className="small" onClick={() => setCardZoom(z => Math.min(1.2, +(z + 0.1).toFixed(2)))}>+</button>
//             </div>
//           </div>

//           <div className="work" style={{ justifyContent: "center" }}>
//             <div className="vfc-a4" onMouseDown={onA4MouseDown} ref={a4Ref}>
//               {(activeSide === 'front' || showBoth) && (
//                 <div className="a4-inner">
//                   {showCard && (
//                     <div className="card-wrapper" ref={frontCardRef} style={{ transform: `scale(${cardZoom})` }}>
//                       <div bounds="parent" size={{ width: cardPxW, height: cardPxH }}>
//                         <div
//                           ref={cardRef}
//                           className="card-node"
//                           //onMouseDown={(ev) => { ev.stopPropagation(); }} // avoid A4 click from deselecting immediately
//                           //onClick={(ev) => onCardBackgroundClick(ev)} // open background controls if clicked on blank
//                           style={{
//                             background: cardBg ?? "transparent",
//                             width: `${cardMm.w}mm`,
//                             height: `${cardMm.h}mm`,
//                           }}
//                         >
//                           <div className="card-guides">
//                             <div className="bleed" />
//                             <div className="bleed-line" />
//                             <div className="safe" />
//                           </div>

//                           {/* elements layer */}
//                           <div className="card-elements">
//                             {elements.map(el => {
//                               if (el.type === "text") {
//                                 return (
//                                   <Rnd
//                                     key={el.id}
//                                     bounds="parent"
//                                     className="rnd-box"
//                                     size={{ width: el.width, height: el.height }}
//                                     position={{ x: el.x, y: el.y }}
//                                     onDragStart={() => setSelectedId(el.id)}
//                                     onDragStop={(e, d) =>
//                                       updateElement(el.id, {
//                                         x: Math.max(0, Math.round(d.x)),
//                                         y: Math.max(0, Math.round(d.y)),
//                                       })
//                                     }
//                                     onResizeStop={(e, dir, ref, delta, position) =>
//                                       updateElement(el.id, {
//                                         width: Math.max(20, ref.offsetWidth),
//                                         height: Math.max(16, ref.offsetHeight),
//                                         x: Math.max(0, Math.round(position.x)),
//                                         y: Math.max(0, Math.round(position.y)),
//                                       })
//                                     }
//                                     onClick={(ev) => {
//                                       ev.stopPropagation();
//                                       setSelectedId(el.id);
//                                     }}

//                                   >
//                                     <div
//                                       style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         fontSize: el.fontSize,
//                                         color: el.color,
//                                         fontFamily: el.fontFamily,
//                                         fontWeight: el.isBold ? "bold" : "normal",
//                                         fontStyle: el.isItalic ? "italic" : "normal",
//                                       }}
//                                     >
//                                       {el.text}
//                                     </div>
//                                   </Rnd>
//                                 );
//                               }

//                               /** --------------------------
//                                *  IMAGE ELEMENT RENDER
//                                * -------------------------- */
//                               if (el.type === "image") {
//                                 // const isRemote = el.src.startsWith("http");
//                                 return (
//                                   <Rnd
//                                     key={el.id}
//                                     bounds="parent"
//                                     className="rnd-box"
//                                     size={{ width: el.width, height: el.height }}
//                                     position={{ x: el.x, y: el.y }}
//                                     onDragStart={() => setSelectedId(el.id)}
//                                     onDragStop={(e, d) =>
//                                       updateElement(el.id, {
//                                         x: Math.max(0, Math.round(d.x)),
//                                         y: Math.max(0, Math.round(d.y)),
//                                       })
//                                     }
//                                     onResizeStop={(e, dir, ref, delta, position) =>
//                                       updateElement(el.id, {
//                                         width: Math.max(10, ref.offsetWidth),
//                                         height: Math.max(10, ref.offsetHeight),
//                                         x: Math.max(0, Math.round(position.x)),
//                                         y: Math.max(0, Math.round(position.y)),
//                                       })
//                                     }
//                                     onClick={(ev) => {
//                                       ev.stopPropagation();
//                                       setSelectedId(el.id);
//                                     }}
//                                   //   onClick={(ev) => {
//                                   //   ev.stopPropagation();
//                                   //   setSelectedId(el.id);

//                                   //   // Load this element's image into the modal
//                                   //   setSelectedImagee(el.src);
//                                   //   setImageShape(el.shape || "square");
//                                   //   setImageFit(el.objectFit || "cover");

//                                   //   // Open the image modal
//                                   //   setShowImageModal(true);
//                                   // }}
//                                   >
//                                     <img
//                                       src={el.src}

//                                       style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         objectFit: el.objectFit || "cover",
//                                         borderRadius:
//                                           el.shape === "circle"
//                                             ? "50%"
//                                             : el.shape === "rounded"
//                                               ? "12px"
//                                               : "0px",
//                                       }}
//                                     />
//                                   </Rnd>
//                                 );
//                               }

//                               return null;
//                             })}


//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                 </div>

//               )}
//               {/*** Back Card */}
//               {(activeSide === 'back' || showBoth) && (
//                 <div className="a4-inner">

//                   {/* Card (draggable/resizable via Rnd) */}
//                   {showCard && (
//                     <div className="card-wrapper_back" ref={backCardRef} style={{ transform: `scale(${cardZoom})`, marginLeft: "auto" }}>
//                       <div
//                         bounds="parent"
//                         size={{ width: cardPxW, height: cardPxH }}
//                         // position={{ x: cardPos.x, y: cardPos.y }}
//                         // onDragStop={(e, d) => {
//                         //   setCardPos({ x: Math.max(0, Math.round(d.x)), y: Math.max(0, Math.round(d.y)) });
//                         // }}
//                         // onResize={(e, direction, ref, delta, position) => {
//                         //   // during resize update px dims
//                         //   const newWpx = ref.offsetWidth;
//                         //   const newHpx = ref.offsetHeight;
//                         //   const newWmm = Math.max(10, +(pxToMm(newWpx)).toFixed(2));
//                         //   const newHmm = Math.max(10, +(pxToMm(newHpx)).toFixed(2));
//                         //   setCardMm({ w: newWmm, h: newHmm });
//                         //   setCardPos({ x: Math.max(0, Math.round(position.x)), y: Math.max(0, Math.round(position.y)) });
//                         // }}
//                         // onResizeStop={(e, direction, ref, delta, position) => {
//                         //   // finalize sizes after resize
//                         //   const newWmm = Math.max(10, +(pxToMm(ref.offsetWidth)).toFixed(2));
//                         //   const newHmm = Math.max(10, +(pxToMm(ref.offsetHeight)).toFixed(2));
//                         //   setCardMm({ w: newWmm, h: newHmm });
//                         //   setCardPos({ x: Math.max(0, Math.round(position.x)), y: Math.max(0, Math.round(position.y)) });
//                         // }}
//                         // onClick={(e) => { e.stopPropagation(); setSelectedId(null); }}
//                         // dragHandleClassName="card-drag-handle"
//                         // enableResizing={{
//                         //   top: true, right: true, bottom: true, left: true,
//                         //   topRight: true, bottomRight: true, bottomLeft: true, topLeft: true
//                         // }}
//                         style={{ zIndex: 30 }}
//                       >
//                         <div
//                           ref={cardRefBack}
//                           className="card-node"
//                           //onMouseDown={(ev) => { ev.stopPropagation(); }} // avoid A4 click from deselecting immediately
//                           //onClick={(ev) => onCardBackgroundClick(ev)} // open background controls if clicked on blank
//                           style={{
//                             background: cardBgBack ?? "transparent",
//                             width: `${cardMm.w}mm`,
//                             height: `${cardMm.h}mm`,
//                           }}
//                         >
//                           <div className="card-guides">
//                             <div className="bleed" />
//                             <div className="bleed-line" />
//                             <div className="safe" />
//                           </div>

//                           {/* elements layer */}
//                           <div className="card-elements">
//                             {elementsBack.map(el => {

//                               /** --------------------------
//                                *  TEXT ELEMENT RENDER
//                                * -------------------------- */
//                               if (el.type === "text") {
//                                 return (
//                                   <Rnd
//                                     key={el.id}
//                                     bounds="parent"
//                                     className="rnd-box"
//                                     size={{ width: el.width, height: el.height }}
//                                     position={{ x: el.x, y: el.y }}
//                                     onDragStart={() => setSelectedId(el.id)}
//                                     onDragStop={(e, d) =>
//                                       updateElement(el.id, {
//                                         x: Math.max(0, Math.round(d.x)),
//                                         y: Math.max(0, Math.round(d.y)),
//                                       })
//                                     }
//                                     onResizeStop={(e, dir, ref, delta, position) =>
//                                       updateElement(el.id, {
//                                         width: Math.max(20, ref.offsetWidth),
//                                         height: Math.max(16, ref.offsetHeight),
//                                         x: Math.max(0, Math.round(position.x)),
//                                         y: Math.max(0, Math.round(position.y)),
//                                       })
//                                     }
//                                     onClick={(ev) => {
//                                       ev.stopPropagation();
//                                       setSelectedId(el.id);
//                                     }}
//                                   >
//                                     <div
//                                       style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         fontSize: el.fontSize,
//                                         color: el.color,
//                                         fontFamily: el.fontFamily,
//                                         fontWeight: el.isBold ? "bold" : "normal",
//                                         fontStyle: el.isItalic ? "italic" : "normal",
//                                       }}
//                                     >
//                                       {el.text}
//                                     </div>
//                                   </Rnd>
//                                 );
//                               }

//                               /** --------------------------
//                                *  IMAGE ELEMENT RENDER
//                                * -------------------------- */
//                               if (el.type === "image") {
//                                 return (
//                                   <Rnd
//                                     key={el.id}
//                                     bounds="parent"
//                                     className="rnd-box"
//                                     size={{ width: el.width, height: el.height }}
//                                     position={{ x: el.x, y: el.y }}
//                                     onDragStart={() => setSelectedId(el.id)}
//                                     onDragStop={(e, d) =>
//                                       updateElement(el.id, {
//                                         x: Math.max(0, Math.round(d.x)),
//                                         y: Math.max(0, Math.round(d.y)),
//                                       })
//                                     }
//                                     onResizeStop={(e, dir, ref, delta, position) =>
//                                       updateElement(el.id, {
//                                         width: Math.max(10, ref.offsetWidth),
//                                         height: Math.max(10, ref.offsetHeight),
//                                         x: Math.max(0, Math.round(position.x)),
//                                         y: Math.max(0, Math.round(position.y)),
//                                       })
//                                     }
//                                     onClick={(ev) => {
//                                       ev.stopPropagation();
//                                       setSelectedId(el.id);
//                                     }}
//                                   >
//                                     <img
//                                       src={el.src}
//                                       style={{
//                                         width: "100%",
//                                         height: "100%",
//                                         objectFit: el.objectFit || "cover",
//                                         borderRadius:
//                                           el.shape === "circle"
//                                             ? "50%"
//                                             : el.shape === "rounded"
//                                               ? "12px"
//                                               : "0px",
//                                       }}
//                                     />
//                                   </Rnd>
//                                 );
//                               }

//                               return null;
//                             })}
//                             <div className="_newcard-qr">
//                               <QRCodeWithLogo websiteurl={websiteurl} qrCodeSize={qrCodeSize} logoSize={logoSize} />
//                             </div>
//                             {/* <Rnd
//                                         bounds="parent"
//                                         size={{ width: qrSizeWidth, height: qrSizeHeight }}
//                                         position={{ x: qrPos.x, y: qrPos.y }}
//                                         onDragStop={(e, d) => {
//                                           setQrPos({
//                                             x: Math.max(0, Math.round(d.x)),
//                                             y: Math.max(0, Math.round(d.y)),
//                                           });
//                                         }}
//                                         onResizeStop={(e, dir, ref, delta, position) => {
//                                           setQrSizeWidth(ref.offsetWidth);
//                                           setQrSizeHeight(ref.offsetHeight);
//                                           setQrPos({
//                                             x: Math.max(0, Math.round(position.x)),
//                                             y: Math.max(0, Math.round(position.y)),
//                                           });
//                                         }}
//                                         className="_newcard-qr"
//                                       >
//                                         <QRCodeWithLogo
//                                           websiteurl={websiteurl}
//                                           qrCodeSize={qrCodeSize}
//                                           logoSize={logoSize}
//                                         />
//                                       </Rnd> */}

//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div >























//         {/* Right preview / controls */}
//         < div className="right-panel" >
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
//             <strong>Preview</strong>
//             <div style={{ fontSize: 12, color: "#666" }}>{Math.round(cardPos.x)}px, {Math.round(cardPos.y)}px</div>
//           </div>

//           <div>
//             <Button style={{ margin: '10px' }} onClick={() => setActiveSide("front")} title="Front Card"><FaArrowLeft /></Button>
//             <Button style={{ margin: '10px' }} onClick={() => setActiveSide("back")} title="Back Card"><FaArrowRight /></Button>
//             <Button style={{ margin: '10px' }} onClick={() => setShowBoth(b => !b)} title={showBoth ? "Show Single Card" : "Show Both Cards"}><FaEye /></Button>
//           </div>

//           <div style={{ marginTop: 8 }}>
//             <div style={{ marginBottom: 6, fontSize: 13 }}>Card mm</div>
//             <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//               <div style={{ padding: 6, border: "1px solid #eee", borderRadius: 8 }}>{cardMm.w.toFixed(2)} mm</div>
//               <div style={{ padding: 6, border: "1px solid #eee", borderRadius: 8 }}>{cardMm.h.toFixed(2)} mm</div>
//             </div>
//           </div>

//           <div style={{ marginTop: 12 }}>
//             <div style={{ display: "flex", gap: 8 }}>
//               <button className="small" onClick={() => setShowCard(s => !s)}>{showCard ? "Hide Card" : "Show Card"}</button>
//               <button className="small" onClick={() => {
//                 // reset to default
//                 setCardMm({ w: 88, h: 55 });
//                 setCardPos({ x: 40, y: 40 });
//               }}>Reset Size</button>
//             </div>
//           </div>

//           {/* <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
//           {imageUrls.map(img => (
//             <div key={img.id}>
//               <img 
//                 src={img.imageUrl}
//                 alt={img.imageName}
//                 width={200}
//                 style={{ borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.2)" }}
//               />

//             </div>
//           ))}
//         </div> */}
//           <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", maxHeight: "300px", overflowY: "auto", paddingRight: "10px", marginTop: '20px' }}>
//             {imageUrls.map(img => (
//               <div
//                 key={img.id}
//                 style={{ cursor: "pointer" }}
//                 onClick={() => {
//                   setSelectedImage_card(img);
//                   setShowModal_card(true);
//                 }}
//               >
//                 <img src={img.imageUrl} alt={img.imageName} width={170} style={{ borderRadius: "10px", boxShadow: "0 4px 10px rgba(0,0,0,0.2)" }} />
//               </div>
//             ))}
//           </div>


//           {/* <Modal
//           isOpen={showModal_card}
//           onRequestClose={() => setShowModal_card(false)}
//           style={{
//             overlay: {
//               backgroundColor: "rgba(0,0,0,0.7)",
//               zIndex: 9999,
//             },
//             content: {
//               width: "60%",
//               height: "70%",
//               margin: "auto",
//               borderRadius: "15px",
//               padding: "20px",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               justifyContent: "center",
//               border: "2px solid black",
//             }
//           }}
//         >
//           {selectedImage_card && (
//             <>
//               <img
//                 src={selectedImage_card.imageUrl}
//                 alt={selectedImage_card.imageName}
//                 style={{
//                   width: "80%",
//                   height: "auto",
//                   borderRadius: "12px",
//                   boxShadow: "0 6px 18px rgba(0,0,0,0.25)"
//                 }}
//               />

//               <button
//                 style={{
//                   marginTop: "20px",
//                   padding: "10px 20px",
//                   borderRadius: "8px",
//                   background: "#111",
//                   color: "#fff",
//                   border: "none",
//                   fontSize: "16px",
//                   cursor: "pointer"
//                 }}
//                 onClick={() => setShowModal_card(false)}
//               >
//                 Close
//               </button>
//             </>
//           )}
//         </Modal> */}

//           <Modal
//             isOpen={showModal_card}
//             onRequestClose={() => setShowModal_card(false)}
//             style={{
//               overlay: {
//                 backgroundColor: "rgba(0,0,0,0.7)",
//                 zIndex: 9999,
//               },
//               content: {
//                 width: "60%",
//                 height: "70%",
//                 margin: "auto",
//                 borderRadius: "15px",
//                 padding: "20px",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 border: "2px solid black",
//               }
//             }}
//           >
//             {selectedImage_card && (
//               <>
//                 <img
//                   src={selectedImage_card.imageUrl}
//                   alt={selectedImage_card.imageName}
//                   style={{
//                     width: "80%",
//                     height: "auto",
//                     borderRadius: "12px",
//                     boxShadow: "0 6px 18px rgba(0,0,0,0.25)"
//                   }}
//                 />

//                 {/* ✅ DOWNLOAD BUTTON */}
//                 <button
//                   style={{
//                     marginTop: "20px",
//                     padding: "10px 20px",
//                     borderRadius: "8px",
//                     background: "green",
//                     color: "#fff",
//                     border: "none",
//                     fontSize: "16px",
//                     cursor: "pointer"
//                   }}
//                   // onClick={async () => {
//                   //   const imageUrl = selectedImage_card.imageUrl;
//                   //   const imageName = selectedImage_card.imageName || "downloaded_image.jpg";

//                   //   try {
//                   //     const response = await fetch(imageUrl);
//                   //     const blob = await response.blob();

//                   //     const downloadUrl = URL.createObjectURL(blob);

//                   //     const link = document.createElement("a");
//                   //     link.href = downloadUrl;
//                   //     link.download = imageName;
//                   //     document.body.appendChild(link);
//                   //     link.click();
//                   //     document.body.removeChild(link);

//                   //     URL.revokeObjectURL(downloadUrl);
//                   //   } catch (error) {
//                   //     console.error("Download failed:", error);
//                   //   }
//                   // }}

//                   onClick={async () => {
//                     const imageUrl = selectedImage_card.imageUrl;
//                     const imageName = selectedImage_card.imageName || "downloaded_image.png";
//                     try {
//                       const img = new Image();
//                       img.crossOrigin = "anonymous";
//                       img.src = imageUrl;
//                       img.onload = () => {
//                         const canvas = document.createElement("canvas");
//                         canvas.width = img.width;
//                         canvas.height = img.height;
//                         const ctx = canvas.getContext("2d");
//                         ctx.drawImage(img, 0, 0);

//                         canvas.toBlob((blob) => {
//                           const link = document.createElement("a");
//                           link.href = URL.createObjectURL(blob);
//                           link.download = imageName;
//                           link.click();
//                           URL.revokeObjectURL(link.href);
//                         }, "image/png");
//                       };
//                     } catch (e) { console.error("Download failed:", e); }
//                   }}>Download</button>
//                 <button style={{ marginTop: "20px", padding: "10px 20px", borderRadius: "8px", background: "#111", color: "#fff", border: "none", fontSize: "16px", cursor: "pointer" }} onClick={() => setShowModal_card(false)}>Close</button>
//               </>
//             )}
//           </Modal>

//         </div >
//       </div >


//     </>
//   )
// }

// export default Vfccard






import React, { useState, useEffect, useRef } from 'react';
import { Button, } from 'react-bootstrap';
import './CardComponent.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import bg2 from '../Theams/bg2.jpg';
import bg3 from '../Theams/bg3.jpg';
import { LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { Rnd } from "react-rnd";
import { FaTextHeight, FaUpload, FaImage, FaTrash, FaClone, FaMinus, FaDownload } from "react-icons/fa";
import Modal from "react-modal";
import html2canvas from 'html2canvas';
import axios from 'axios';
import QRCodeWithLogo from '../QRCode/QRCodeWithLogo';
import { FaArrowLeft, FaArrowRight, FaEye } from 'react-icons/fa';
import { FaSave, FaTimes } from 'react-icons/fa';
import { FaPlus, FaBold, FaItalic, FaChevronDown, FaCheck } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";


Modal.setAppElement("#root");

const Vfccard = () => {



  const [userEmail, setUserEmail] = useState(null);
  const [websiteUrl, setWebsiteUrl] = useState(null);
  const [selectedImagee, setSelectedImagee] = useState("");
  const [selectedImageeBack, setSelectedImageeBack] = useState("");
  const [images1, setImages1] = useState([]);
  const [cards, setCards] = useState([])
  const [selectedImage, setSelectedImage] = useState({
    image1: null,
    image2: null,
  });




  useEffect(() => {
    const email = sessionStorage.getItem("email");
    if (!email) return;
    const fetchExistingCard = async () => {
      try {
        const response = await axios.get('https://api.nfcdesignstudio.com/API/v1/api/getform');
        const allCards = response.data;
        const existingCard = allCards.find(card => card.email?.trim() === email?.trim());
        console.log(existingCard);
        if (existingCard) {
          setUserEmail(existingCard.email);
          setWebsiteUrl(existingCard.websiteUrl);
        }
      } catch (err) {
        console.error("Error fetching existing card:", err);
      }
    };
    fetchExistingCard();
  }, []);


  useEffect(() => {
    if (!websiteUrl) return;

    const fetchWebsiteData = async () => {
      try {
        console.log("Calling API with:", websiteUrl);

        const response = await axios.get(`https://api.nfcdesignstudio.com/API/v1/${websiteUrl}`
        );

        if (Array.isArray(response.data) && response.data.length > 0) {
          setCards(response.data);
        } else {
          setCards(response.data);
        }

        setImages1(response.data.images || []);
      } catch (error) {
        console.error("Error fetching website data:", error);
      }
    };
    fetchWebsiteData();
  }, [websiteUrl]);


  console.log(cards)


  const websiteurl = (`https://nfcdesignstudio.com/cardurl/${websiteUrl}`);

  const qrCodeSize = 256; // Size of the QR code
  const logoSize = 80;    // Size of the logo/image




  const [selectedBg, setSelectedBg] = useState(bg3); // Default background

  const bgStyles = {
    // [bg1]: {
    //   color: 'white',
    //     fontFamily: 'Courier New, monospace'

    // },
    [bg2]: { fontFamily: 'Georgia, serif' },
    [bg3]: { fontFamily: 'Arial, sans-serif' }
  };
  const currentStyle = bgStyles[selectedBg] || {};

  const [showPopupTheme, setShowPopupTheme] = useState(false);
  const [tempSelectedBg, setTempSelectedBg] = useState(null);
  useEffect(() => {
    if (showPopupTheme) {
      setTempSelectedBg(selectedBg);
    }
  }, [showPopupTheme]);

  // new card 
  const banner =
    cards.image2 && cards.image2.trim() !== "" && cards.image2.toUpperCase() !== "NULL"
      ? cards.image2
      : images1 && images1.length > 0 && images1[0] && images1[0].trim() !== "" && images1[0].toUpperCase() !== "NULL"
        ? images1[0]
        : null;



  //==============================================
  //==============================================


  const STORAGE_KEY = "vfc_card_elements_v1";
  const STORAGE_KEY_BACK = "vfc_card_elementsBack_v2";


  const [showTextModal, setShowTextModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);


  const [showTextModalBack, setShowTextModalBack] = useState(false);
  const [showImageModalBack, setShowImageModalBack] = useState(false);


  const [imageShape, setImageShape] = useState("square");
  const [imageFit, setImageFit] = useState("cover");


  const [elements, setElements] = useState(() => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));

      // Ensure it is always an array
      return Array.isArray(stored) ? stored : [];
    } catch (err) {
      return [];
    }
  });


  // Back card elemets

  const [elementsBack, setElementsBack] = useState(() => {
    try {
      const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));

      // Ensure it is always an array
      return Array.isArray(stored) ? stored : [];
    } catch (err) {
      return [];
    }
  });



  const [selectedId, setSelectedId] = useState(null);


  // toolbar states (applied to selected element)
  const API_KEY = "AIzaSyApkHUS4orQvE9x6tgUj7V7uxiKSOwKPAE"; // move to .env later
  const [fonts, setFonts] = useState([]);
  const [fontFamily, setFontFamily] = useState("Arimo");
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetch(
      `https://www.googleapis.com/webfonts/v1/webfonts?key=${API_KEY}&sort=alpha`
    )
      .then((res) => res.json())
      .then((data) => {
        setFonts(data.items);
        if (data.items.length > 0) {
          setFontFamily(data.items[0].family);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (!fontFamily) return;

    const link = document.createElement("link");
    link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
      / /g,
      "+"
    )}&display=swap`;
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [fontFamily]);

  // const filteredFonts = fonts.filter((font) =>
  //   font.family.toLowerCase().includes(search.toLowerCase())
  // );











  const [fontSize, setFontSize] = useState(24);
  const [fontColor, setFontColor] = useState("#111111");
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [textAlign, setTextAlign] = useState("left");

  // sample uploaded image path (developer-provided uploaded file)
  const sampleLogoUrl = "/mnt/data/3fb6be9d-c971-4e00-b90f-b53691650458.png";

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY_BACK, JSON.stringify(elementsBack));
  }, [elementsBack]);


  useEffect(() => {
    // When selection changes, populate toolbar states from element
    if (!selectedId) return;
    const el = elements.find((e) => e.id === selectedId);
    if (!el) return;
    setFontFamily(el.fontFamily || "Arimo");
    setFontSize(el.fontSize || 24);
    setFontColor(el.color || "#111111");
    setIsBold(!!el.bold);
    setIsItalic(!!el.italic);
    setTextAlign(el.align || "left");
  }, [selectedId]); // eslint-disable-line

  const addTextField = () => {
    const id = "el_" + Date.now();
    const newEl = {
      id,
      type: "text",
      text: "New Text",
      x: 12,
      y: 12,
      width: 60, // px (will be scaled)
      height: 18,
      rotation: 0,
      fontFamily: "Arimo",
      fontSize: 24,
      color: "#111111",
      bold: false,
      italic: false,
      align: "left",
    };
    setElements((s) => [...s, newEl]);
    setSelectedId(id);
  };

  const updateElement = (id, patch) => {
    // console.log('this is id and patch', id, patch)
    setElementsBack(prev => prev.map(p => p.id === id ? { ...p, ...patch } : p));
    setElements((prev) => prev.map((p) => (p.id === id ? { ...p, ...patch } : p)));
  };



  const removeElement = (id) => {
    setElements((prev) => prev.filter((p) => p.id !== id));
    if (selectedId === id) setSelectedId(null);
  };



  const duplicateElement = (id, isBack = false) => {
    const list = isBack ? elementsBack : elements;
    const updater = isBack ? setElementsBack : setElements;

    const el = list.find(e => e.id === id);
    if (!el) return;

    const copy = {
      ...JSON.parse(JSON.stringify(el)),
      id: "el_" + Date.now(),
      x: el.x + 8,
      y: el.y + 8,
    };

    updater(prev => [...prev, copy]);
    setSelectedId(copy.id);
  };


  const rotateSelected = (id, degDelta = 15) => {
    const el = elements.find((e) => e.id === id);
    if (!el) return;
    updateElement(id, { rotation: (el.rotation + degDelta) % 360 });
  };

  const applyToolbarToSelected = () => {
    if (!selectedId) return;
    updateElement(selectedId, {
      fontFamily,
      fontSize,
      color: fontColor,
      bold: isBold,
      italic: isItalic,
      align: textAlign,
    });
  };

  useEffect(() => {
    applyToolbarToSelected();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontFamily, fontSize, fontColor, isBold, isItalic, textAlign]);


  const CARD_MM = { w: 88, h: 55 };




  //============================
  //=============================



  // px per mm measurement
  const [pxPerMm, setPxPerMm] = useState(3.78); // default fallback ~96 DPI -> 3.78 px/mm

  // card mm dimensions (user-visible and editable)
  const [cardMm, setCardMm] = useState({ w: 88, h: 55 }); // mm
  const [cardPos, setCardPos] = useState({ x: 40, y: 40 }); // px within A4 container
  const [cardZoom, setCardZoom] = useState(1); // zoom only for card
  const [cardBg, setCardBg] = useState("#ffffff"); // background color (transparent if null)
  const [showCard, setShowCard] = useState(false);

  // Back card

  const [cardBgBack, setCardBgBack] = useState("#000000ff");

  const [sidebarOpenPanel, setSidebarOpenPanel] = useState("text"); // "text" | "background" | other
  const [sidebarOpenPanelBack, setSidebarOpenPanelBack] = useState("text");
  const [expandedTextRows, setExpandedTextRows] = useState({}); // id:true/false
  const a4Ref = useRef(null);
  const cardRef = useRef(null);
  const cardRefBack = useRef(null);
  // sample uploaded logo path (developer-provided)
  //const sampleLogoUrl = "/mnt/data/3fb6be9d-c971-4e00-b90f-b53691650458.png";

  // measure px/mm on mount and on resize
  useEffect(() => {
    function measure() {
      const el = document.createElement("div");
      el.style.width = "100mm";
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const px = el.getBoundingClientRect().width;
      document.body.removeChild(el);
      if (px > 0) setPxPerMm(px / 100);
    }
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  // persist to sessionStorage
  useEffect(() => {
    const payload = {
      cardMm, cardPos, cardBg, elements
    };

    // sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));

  }, [cardMm, cardPos, cardBg, elements, elementsBack]);

  useEffect(() => {
    const payload1 = {
      cardMm, cardPos, cardBg, elementsBack
    };
    // sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    sessionStorage.setItem(STORAGE_KEY_BACK, JSON.stringify(payload1));

  }, [cardMm, cardPos, cardBg, elements, elementsBack]);



  useEffect(() => {
    try {
      const savedFront = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
      const savedBack = JSON.parse(sessionStorage.getItem(STORAGE_KEY_BACK));
      const savedMeta = JSON.parse(sessionStorage.getItem("CARD_META"));

      if (Array.isArray(savedFront)) setElements(savedFront);
      if (Array.isArray(savedBack)) setElementsBack(savedBack);

      if (savedMeta?.cardMm) setCardMm(savedMeta.cardMm);
      if (savedMeta?.cardPos) setCardPos(savedMeta.cardPos);
      if (savedMeta?.cardBg !== undefined) setCardBg(savedMeta.cardBg);

      setShowCard(
        (Array.isArray(savedFront) && savedFront.length > 0) ||
        (Array.isArray(savedBack) && savedBack.length > 0) ||
        !!savedMeta?.cardMm || true
      );
    } catch {
      // ignore errors
    }
  }, []);


  // helpers: add text
  const addText = () => {
    const id = "t_" + Date.now();
    const defaultPxW = 80;
    // console.log('this is defaultPxW', defaultPxW)
    const defaultPxH = 30;
    const newT = {
      id,
      type: "text",
      text: "New Text",

      x: Math.round(defaultPxW),
      y: Math.round(defaultPxH),

      width: defaultPxW,
      height: defaultPxH,
      fontFamily: "Arimo",
      fontSize: 16,
      color: "#111111",
      bold: false,
      italic: false,
      align: "left",
      rotation: 0,
    };
    setElements(prev => [...prev, newT]);
    setExpandedTextRows(prev => ({ ...prev, [id]: true }));
    setSelectedId(id);
    setShowCard(true);
  };

  const addTextBack = () => {
    const id = "t_" + Date.now();
    const defaultPxW = 80;
    const defaultPxH = 30;
    const newT = {
      id,
      type: "text",
      text: "New Text",
      x: Math.round(defaultPxW),
      y: Math.round(defaultPxH),

      width: defaultPxW,
      height: defaultPxH,
      fontFamily: "Arimo",
      fontSize: 16,
      color: "#111111",
      bold: false,
      italic: false,
      align: "left",
      rotation: 0,
    };
    setElementsBack(prev => [...prev, newT]);
    setExpandedTextRows(prev => ({ ...prev, [id]: true }));
    setSelectedId(id);
    setShowCard(true);
  };




  const addImageElement = () => {
    if (!selectedImagee) return;
    // console.log("Selected image when Saving = ", selectedImagee);

    const id = "i_" + Date.now(); // unique ID for image
    const newImage = {
      id,
      type: "image",
      src: selectedImagee,
      shape: imageShape || "square",
      objectFit: imageFit || "cover",
      x: 20, // default position
      y: 20,
      width: 100,
      height: 100,
    };

    setElements(prev => [...prev, newImage]);
    setSelectedId(id); // select newly added image
    setShowCard(true);
    setShowImageModal(false);
  };

  const addImageElementBack = () => {
    if (!selectedImageeBack) return;

    const id = "i_" + Date.now(); // unique ID for image
    const newImage = {
      id,
      type: "image",
      src: selectedImageeBack,
      shape: imageShape || "square",
      objectFit: imageFit || "cover",
      x: 20, // default position
      y: 20,
      width: 100,
      height: 100,
    };

    setElementsBack(prev => [...prev, newImage]);
    setSelectedId(id); // select newly added image
    setShowCard(true);
    setShowImageModal(false);
  };


  // const updateElement = (id, patch) => {
  //   setElements(prev => prev.map(e => e.id === id ? { ...e, ...patch } : e));
  // };
  const deleteElement = (id) => {
    setElements(prev => prev.filter(e => e.id !== id));
    setElementsBack(prev => prev.filter(e => e.id !== id));
    setSelectedId(s => s === id ? null : s);
    setExpandedTextRows(prev => { const c = { ...prev }; delete c[id]; return c; });
  };



  const mmDisplay = `${cardMm.w.toFixed(2)} × ${cardMm.h.toFixed(2)} mm`;

  // clicking on A4 outside card should deselect
  const onA4MouseDown = (ev) => {
    // if clicked directly on A4 background (not inside card), deselect
    // check if click target is inside cardRef
    if (!cardRef.current) {
      setSelectedId(null);
      return;
    }
    if (!cardRef.current.contains(ev.target)) {
      setSelectedId(null);
      // also collapse expanded rows? keep as-is
    }
  };


  // card px dims derived from mm -> px
  const cardPxW = Math.round(cardMm.w * pxPerMm);
  const cardPxH = Math.round(cardMm.h * pxPerMm);


  // available CMYK-ish swatches (approx hex equivalents)
  const cmykSwatches = [
    { name: "C 100 M 0 Y 0 K 0", hex: "#0085CA" },
    { name: "M 100 C 0 Y 0 K 0", hex: "#E4007F" },
    { name: "Y 100 C 0 M 0 K 0", hex: "#FFCC00" },
    { name: "K 100 C 0 M 0 Y 0", hex: "#111111" },
    { name: "C 50 M 0 Y 0 K 0", hex: "#4CAFEA" },

    { name: "C 100 M 100 Y 0 K 0", hex: "#5B2D90" },
    { name: "C 0 M 100 Y 100 K 0", hex: "#ED1C24" },
    { name: "C 0 M 50 Y 100 K 0", hex: "#F7941D" },
    { name: "C 75 M 0 Y 100 K 0", hex: "#39B54A" },
    { name: "C 100 M 0 Y 100 K 0", hex: "#00A651" },

    { name: "C 60 M 100 Y 0 K 0", hex: "#92278F" },
    { name: "C 30 M 100 Y 0 K 0", hex: "#C127B0" },
    { name: "C 0 M 100 Y 50 K 0", hex: "#EC008C" },
    { name: "C 0 M 75 Y 100 K 0", hex: "#F15A24" },
    { name: "C 0 M 25 Y 100 K 0", hex: "#FCEE21" },

    { name: "C 100 M 50 Y 0 K 0", hex: "#0072BC" },
    { name: "C 100 M 25 Y 0 K 0", hex: "#00AEEF" },
    { name: "C 75 M 25 Y 0 K 0", hex: "#29ABE2" },
    { name: "C 50 M 25 Y 0 K 0", hex: "#7ACCC8" },
    { name: "C 25 M 0 Y 50 K 0", hex: "#8DC63F" },

    { name: "C 0 M 0 Y 0 K 50", hex: "#808285" },
    { name: "C 0 M 0 Y 0 K 75", hex: "#58595B" },
    { name: "C 0 M 0 Y 0 K 25", hex: "#BFC0C2" },
    { name: "C 20 M 20 Y 20 K 0", hex: "#D1D3D4" },
    { name: "C 10 M 0 Y 0 K 0", hex: "#D6EFFC" },

    { name: "C 0 M 10 Y 0 K 0", hex: "#F8D7E8" },
    { name: "C 0 M 0 Y 10 K 0", hex: "#FFF9C4" },
    { name: "C 15 M 0 Y 15 K 0", hex: "#E6F5E9" },
    { name: "C 0 M 15 Y 15 K 0", hex: "#FDEBD0" },
    { name: "C 40 M 0 Y 40 K 0", hex: "#A2D39C" },
  ];











  //======================================
  //======================================

  const [activeSide, setActiveSide] = useState("front");

  const [showBoth, setShowBoth] = useState(false);


  const frontCardRef = useRef(null);
  const backCardRef = useRef(null);




  const [imageUrls, setImageUrls] = useState([]);




  const downloadCard = async (ref, filename, cardType) => {
    const card = ref.current;
    if (!card) return;

    // hide borders & guides
    const rndBoxes = card.querySelectorAll(".rnd-box");
    const guides = card.querySelectorAll(".card-guides");
    rndBoxes.forEach(el => (el.style.border = "none"));
    guides.forEach(el => (el.style.display = "none"));

    const canvas = await html2canvas(card, { scale: 3 });

    // restore UI
    rndBoxes.forEach(el => (el.style.border = ""));
    guides.forEach(el => (el.style.display = ""));

    const base64 = canvas.toDataURL("image/png");
    const blob = await fetch(base64).then(res => res.blob());
    const file = new File([blob], filename + ".png", { type: "image/png" });

    const link = document.createElement("a");
    link.download = `${filename}.png`;
    link.href = base64;
    link.click();

    const loggedUser = sessionStorage.getItem("email");
    const formData = new FormData();
    formData.append("email", loggedUser);
    formData.append("file", file);
    formData.append("cardType", cardType);

    try {
      await axios.post("https://api.nfcdesignstudio.com/API/v1/uploadPng", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert(`PNG saved successfully (${cardType})`);
    } catch (err) {
      console.error(err);
      alert("Upload failed");
    }
  };
  ;

  const cardRefs = useRef({}); // store refs keyed by img.id


  const downloadImage = async (id, filename, imageUrl) => {
    const confirmDownload = window.confirm(`Do you want to download "${filename}"?`);
    if (!confirmDownload) return;

    try {
      const response = await fetch(imageUrl, { mode: 'cors' });
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed:", err);
      // Fallback: open in new tab if fetch fails
      window.open(imageUrl, "_blank");
    }
  };








  useEffect(() => {
    // const loggedUser = JSON.parse(sessionStorage.getItem("userData"));
    const loggedUser = sessionStorage.getItem("email")
    if (!loggedUser) return;

    axios
      .get(`https://api.nfcdesignstudio.com/API/v1/getPng/${loggedUser}`)
      .then(res => {
        setImageUrls(res.data); // array of { id, imageUrl, imageName }
      })
      .catch(err => console.log(err));
  }, []);




  const [backendTextList, setBackendTextList] = useState([]);

  const backendData = {
    name: cards.name,
    designation: cards.designation,
    companyName: cards.companyName,
    phoneNumber: cards.phoneNumber,
    email: cards.email,
    address: cards.address,
    website: cards.website,

  };

  const backendTextElements = Object.entries(backendData)
    .filter(([key, value]) => value && value !== "") // only non-empty fields
    .map(([key, value]) => ({
      id: "txt_" + key,
      type: "text",
      text: value,
      fontSize: 16,
      color: "#000",
      x: 50,
      y: 50,
      width: 180,
      height: 40
    }));

  useEffect(() => {
    setBackendTextList(backendTextElements); // store only in modal
  }, [cards]);


  const addBackendTextToCard = (element) => {
    setElementsBack(prev => [...prev, { ...element }]);
  };

  const addfrontTextToCard = (element) => {
    setElements(prev => [...prev, { ...element }]);
  };





  // this is Profile page code 

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      sessionStorage.clear();   // clear session storage
      sessionStorage.removeItem("email"); // optional if needed
      window.location.href = "/";  // redirect to home/login
    }
  };

  const [deleteCandidateId, setDeleteCandidateId] = useState(null);
  const [editingTextId, setEditingTextId] = useState(null);

  const [deleteCandidateIdBack, setDeleteCandidateIdBack] = useState(null);
  const [editingTextIdBack, setEditingTextIdBack] = useState(null);
  const updateElementBack = (id, updates) => {
    setElementsBack(prev =>
      prev.map(el => (el.id === id ? { ...el, ...updates } : el))
    );
  };



  return (


    <>

      <div style={{ flexShrink: 0, borderBottom: '1px solid #ccc', background: 'rgba(255,255,255,0.5)', backdropFilter: 'blur(10px)', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <div>
          <h2 style={{ fontSize: 24, fontWeight: 'bold', margin: 0 }}>Digital Card Builder</h2>
          <p style={{ fontSize: 14, color: '#555', margin: 0 }}>Create your professional NFC business card</p>
        </div>

        {/* Links */}
        <div style={{ display: 'flex', gap: '16px' }}>
          <Link to="/builder" style={{ textDecoration: "none", color: "#007bff", fontWeight: "500" }}>MY Card</Link>
          {/* <a href="/vfc-card" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }} > VFC Card</a> */}
          <a href="/profile" style={{ textDecoration: 'none', color: '#007bff', fontWeight: '500' }}> Profile</a>
          <a onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "6px", textDecoration: "none", color: "#007bff", fontWeight: "500", cursor: "pointer" }}><LogOut size={16} /> Logout</a>
        </div>
      </div>




      <div style={{ height: "90vh", display: "flex", fontFamily: "Inter, Arial, sans-serif" }}>
        <style>{`
                /* --------- Layout --------- */
                .vfc-sidebar {
                  width: 260px;
                  background: #fff;
                  border-right: 1px solid #e6e6e6;
                  padding: 16px;
                  box-sizing: border-box;
                }
                .vfc-sidebar .group {
                  padding: 8px 0;
                }
                .vfc-sidebar .item {
                  display:flex;
                  gap:12px;
                  align-items:center;
                  padding:10px;
                  border-radius:8px;
                  cursor:pointer;
                  color:#222;
                  margin-bottom:6px;
                }
                .vfc-sidebar .item:hover { background:#f3f9ff; }
        
                .vfc-main {
                  flex:1;
                  display:flex;
                  flex-direction:column;
                  gap:12px;
                  padding: 14px;
                  box-sizing:border-box;
                  background: #f3f4f6;
                }
        
                .vfc-toolbar {
                  background:white;
                  padding:10px 12px;
                  border-radius:10px;
                  display:flex;
                  gap:8px;
                  align-items:center;
                  box-shadow: 0 1px 0 rgba(0,0,0,0.03);
                }
                .vfc-toolbar select, .vfc-toolbar input[type="number"], .vfc-toolbar button, .vfc-toolbar input[type="color"] {
                  border:1px solid #d7d7d7;
                  padding:6px 8px;
                  border-radius:8px;
                  background:white;
                }
                .vfc-toolbar .tool-btn { display:inline-flex; align-items:center; justify-content:center; padding:6px; width:36px; height:36px; border-radius:8px; cursor:pointer; background:white; border:1px solid #eee; }
                .vfc-workarea {
                  display:flex;
                  align-items:flex-start;
                  gap:12px;
                }
        
                /* A4 page centered and sized */
                .vfc-a4 {
                  width:210mm;
                  height:297mm;
                  background: #ffffff;
                  margin: 12px auto;
                  box-shadow: 0 6px 20px rgba(0,0,0,0.12);
                  display:flex;
                  justify-content:center;
                  align-items:center;
                  position:relative;
                }
                .vfc-a4 .a4-inner {
                  width: 100%;
                  height: 100%;
                  padding: 18mm 12mm; /* some inner margin to mimic viewport */
                  box-sizing:border-box;
                }
        
                /* Card container: exact mm */
                .card-frame {
                  width: 88mm;
                  height: 55mm;
                  background: #fff;
                  border-radius: 10px;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
                  position: relative;
                  overflow: visible;
                  display:flex;
                  justify-content:center;
                  align-items:center;
                }
                /* Bleed and safety guides */
                .card-bleed {
                  position:absolute;
                  inset:0;
                  pointer-events:none;
                  border-radius:10px;
                }
                .bleed-line {
                  position:absolute;
                  inset:0;
                  border: 1px solid rgba(0,120,210,0.08);
                  border-radius:10px;
                }
                .safe-area {
                  position:absolute;
                  left: 6mm; top: 6mm; right: 6mm; bottom: 6mm;
                  border: 1px dashed rgba(0,160,120,0.25);
                  border-radius:8px;
                  pointer-events:none;
                }
        
                /* elements placed on card */
                .card-elements {
                  position:absolute;
                  inset:0;
                  pointer-events:none;
                }
        
                /* selected element overlay (icons) */
                .elm-overlay {
                  position:absolute;
                  pointer-events:auto;
                }
                .elm-controls {
                  display:flex;
                  gap:6px;
                  position:absolute;
                  transform: translate(-50%, 8px);
                  left:50%;
                }
        
                /* sidebar text list */
                .text-list {
                  margin-top:18px;
                  background:#fbfdff;
                  padding:10px;
                  border-radius:8px;
                  border:1px solid #f0f6ff;
                }
                .text-row {
                  display:flex;
                  justify-content:space-between;
                  align-items:center;
                  padding:6px 8px;
                  border-bottom:1px solid #f1f1f1;
                }
                .text-row:last-child { border-bottom:none; }
        
                /* right preview */
                .vfc-right {
                  width:220px;
                  padding:12px;
                }
                .mini {
                  background:white;
                  height:100px;
                  border-radius:8px;
                  border:1px solid #e6e6e6;
                  margin-bottom:8px;
                  display:flex;
                  align-items:center;
                  justify-content:center;
                }
        
                /* small helpers */
                .small-btn {
                  border:1px solid #e7e7e7;
                  padding:6px 8px;
                  border-radius:6px;
                  cursor:pointer;
                  background:white;
                }
                .selected-label {
                  font-size:12px; color:#666; margin-left:8px;
                }
        
                /* Rnd inner text style */
                .rnd-text {
                  display:inline-block;
                  pointer-events:auto;
                  user-select:none;
                  padding:4px 6px;
                }
                .rnd-input {
                  width:100%;
                  height:100%;
                  box-sizing:border-box;
                }
        
                /* responsive */
                @media (max-width:1200px) {
                  .vfc-sidebar { display:none; }
                }
        
                        .vfc-left {
                  width: 260px; background: #fff; border-right:1px solid #eee; padding:12px; box-sizing:border-box;
                }
                .vfc-left .item { display:flex; gap:10px; align-items:center; padding:8px; cursor:pointer; border-radius:8px; }
                .vfc-left .item:hover { background:#f3f9ff; }
        
                .vfc-main { flex:1; background:#f3f4f6; padding:12px; box-sizing:border-box; display:flex; flex-direction:column; gap:12px; }
                .vfc-topbar { background:white; padding:10px; border-radius:8px; display:flex; align-items:center; gap:8px; }
                .vfc-topbar .small { padding:6px 8px; border:1px solid #e6e6e6; border-radius:8px; background:white; cursor:pointer; }
                .vfc-main .work { display:flex; gap:12px; align-items:flex-start; }
        
                .vfc-a4 {
                  width:260mm; height:180mm; background:white; border-radios:'10px',box-shadow:0 6px 20px rgba(0,0,0,0.12); margin:auto; position:relative; display:flex; justify-content:center; align-items:center;
                }        
        
                .card-wrapper {position: absolute;
          left: 50px;
          top: 60px; transform-origin: top left; }
                 .card-wrapper_back { position: absolute;
          right: 50px;
          top: 60px;
          transform-origin: top right; }
                .card-node {
                  width:${cardMm.w}mm; height:${cardMm.h}mm; border-radius:9px; position:relative; box-shadow:0 2px 10px rgba(0,0,0,0.08); overflow:visible;
                  display:block;
                }
                .card-guides .bleed { position:absolute; inset:0; border-radius:9px; pointer-events:none; }
                .card-guides .bleed-line { border:1px solid rgba(0, 0, 0, 0.54); position:absolute; inset:0; border-radius:9px; }
                .card-guides .safe { position:absolute; left:6mm; right:6mm; top:6mm; bottom:6mm; border-radius:6px; border:1px dashed rgba(0, 160, 120, 0.52); pointer-events:none; }
                .card-elements { position:absolute; inset:0; pointer-events:auto; }
        
                .text-row { display:flex; justify-content:space-between; align-items:center; padding:6px 8px; border-bottom:1px solid #f1f1f1; }
                .text-row .controls { display:flex; gap:6px; align-items:center; }
        
                .right-panel { width:220px; padding:12px; box-sizing:border-box; background:#fff; border-left:1px solid #eee; }
        
                .mini { height:100px; border:1px solid #eee; border-radius:6px; display:flex; align-items:center; justify-content:center; margin-bottom:8px; background:#fafafa; }
        
                .rnd-box { border:1px solid rgba(255, 0, 0, 0.54); }
              `}</style>








        {/* Left Sidebar */}
        <div className="vfc-left">
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
            <div style={{ fontWeight: 700 }}>My Projects</div>
            <div style={{ color: "#777", fontSize: 12 }}>NFC Visiting Cards</div>
          </div>

          <div style={{ marginBottom: 10 }}>
            <div className="item" onClick={() => { if (activeSide === "front") { setShowTextModal(true); } else { setShowTextModalBack(true); } }}><FaTextHeight /> Text</div>
            <div className="item" onClick={() => { if (activeSide === "front") { setShowImageModal(true); } else { setShowImageModalBack(true); } }}><FaUpload /> Background Image</div>
            {/* <div className="item"><FaShapes /> Graphics</div>  setShowImageModalBack*/}
            {/* <div className="item" onClick={() => setSidebarOpenPanel(true)}><FaImage /> Background</div> */}
            <div className="item" onClick={() => { if (activeSide === "front") { setSidebarOpenPanel(true); } else { setSidebarOpenPanelBack(true); } }}>
              <FaImage /> Background Color
            </div>

            {/* <div className="item"><FaBorderAll /> Template</div> */}
            {/* <div className="item"><FaQrcode /> QR-codes</div> */}
            {/* <div className="item"><FaTable /> Tables</div> */}

            <div style={{ border: "1px solid #e5e7eb", padding: "8px", marginBottom: "20px", background: "#fff" }}>
              <label style={{ display: "block", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>All Text Elements FC</label>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {elements.filter(el => el.type === "text").map(el => (
                  <div
                    key={el.id}
                    onClick={() => {
                      setSelectedId(el.id);
                      setShowTextModal(true);
                      setFontSize(el.fontSize);
                      setFontFamily(el.fontFamily);
                      setIsBold(el.isBold);
                      setIsItalic(el.isItalic);
                    }}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px", borderRadius: "8px", background: selectedId === el.id ? "#eff6ff" : "#f9fafb", border: selectedId === el.id ? "1px solid #2563eb" : "1px solid #e5e7eb", cursor: "pointer", transition: "0.2s" }}>
                    <span style={{ flex: 1, fontSize: "14px", fontWeight: "500", wordBreak: "break-word" }}>{el.text}</span>
                    <span style={{ fontSize: "12px", color: "#6b7280", marginLeft: "8px" }}>{Math.round(el.fontSize)}px</span>
                  </div>
                ))}
              </div>
            </div>


            {/* ALL TEXT ELEMENTS */}
            <div style={{ border: "1px solid #e5e7eb", padding: "8px", marginBottom: "20px", background: "#fff" }}>
              <label style={{ display: "block", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>All Text Elements BC</label>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {elementsBack.filter(el => el.type === "text").map(el => (
                  <div
                    key={el.id}
                    onClick={() => {
                      setSelectedId(el.id);        // select this text element
                      setShowTextModalBack(true);  // OPEN BACK CARD modal
                      setFontSize(el.fontSize);    // load formatting values
                      setFontFamily(el.fontFamily);
                      setIsBold(el.isBold);
                      setIsItalic(el.isItalic);
                    }}
                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px", borderRadius: "8px", background: selectedId === el.id ? "#eff6ff" : "#f9fafb", border: selectedId === el.id ? "1px solid #2563eb" : "1px solid #e5e7eb", cursor: "pointer", transition: "0.2s" }}
                  >
                    <span style={{ flex: 1, fontSize: "14px", fontWeight: "500", wordBreak: "break-word" }}>{el.text}</span>
                    <span style={{ fontSize: "12px", color: "#6b7280", marginLeft: "8px" }}>{Math.round(el.fontSize)}px</span>
                  </div>
                ))}
              </div>
            </div>

          </div>


          {/* Background controls panel when selected */}




          {sidebarOpenPanel && (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", justifyContent: "flex-end", zIndex: 2000 }}>
              {/* Sidebar Panel */}
              <div style={{ width: "100%", maxWidth: "400px", height: "100%", background: "#ffffff", padding: "20px", boxShadow: "-4px 0 15px rgba(0,0,0,0.1)", display: "flex", flexDirection: "column", overflowY: "auto" }}>
                {/* Header */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                  <div>
                    <div style={{ fontSize: "16px", fontWeight: 600 }}>Background Colour Picker Settings</div>
                    <div style={{ fontSize: "12px", color: "#6b7280" }}>{cardMm.w} × {cardMm.h} mm</div>
                  </div>
                  <button onClick={() => setSidebarOpenPanel(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>✕</button>
                </div>

                {/* Color Picker Card */}
                <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", marginBottom: "20px", border: "1px solid #e5e7eb" }}>
                  <div style={{ fontSize: "14px", marginBottom: "10px", fontWeight: 500 }}>Pick Color</div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <input type="color" value={cardBg ?? "#ffffff"} onChange={(ev) => setCardBg(ev.target.value)} style={{ width: "50px", height: "40px", border: "none", cursor: "pointer" }} />
                    <button onClick={() => setCardBg(null)} style={{ background: "#f3f4f6", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}>Remove</button>
                  </div>
                </div>

                {/* CMYK Swatches */}
                <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", border: "1px solid #e5e7eb" }}>
                  <div style={{ fontSize: "14px", marginBottom: "12px", fontWeight: 500 }}>CMYK Swatches</div>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(40px, 1fr))", gap: "10px" }}>
                    {cmykSwatches.map(s => (
                      <div key={s.hex} onClick={() => setCardBg(s.hex)} title={s.name} style={{ width: "100%", aspectRatio: "1 / 1", background: s.hex, borderRadius: "8px", cursor: "pointer", border: cardBg === s.hex ? "3px solid #2563eb" : "1px solid #e5e7eb", transition: "0.2s" }} />
                    ))}
                  </div>
                </div>

                {/* Footer */}
                <div style={{ marginTop: "auto", paddingTop: "20px" }}>
                  <button onClick={() => setSidebarOpenPanel(false)} style={{ width: "100%", background: "#2563eb", color: "#fff", border: "none", padding: "10px", borderRadius: "10px", cursor: "pointer", fontWeight: 500 }}>Done</button>
                </div>
              </div>
            </div>
          )}

          <Modal isOpen={showTextModal} onRequestClose={() => setShowTextModal(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000 }, content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", width: "90%", maxWidth: "1000px", maxHeight: "90vh", overflowY: "auto", padding: "20px", borderRadius: "16px", border: "none" } }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
              <h5 style={{ margin: 0 }}>EDIT TEXT</h5>
              <button onClick={() => setShowTextModal(false)} title="Close" style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}><FaTimes /></button>
            </div>

            <div style={{ background: "#ffffff", borderRadius: "12px", padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", marginTop: "15px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px", flexWrap: "wrap", gap: "10px" }}>
                <strong style={{ fontSize: "16px" }}>Text Elements</strong>
                <button onClick={addText} title="Add Text" style={{ background: "#2563eb", color: "#fff", border: "none", padding: "8px 10px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaPlus /></button>
              </div>
              {elements.filter(e => e.type === "text").length === 0 && (
                <div style={{ textAlign: "center", padding: "20px", background: "#f9fafb", borderRadius: "10px", color: "#6b7280", fontSize: "14px" }}>
                  No text yet
                  <div style={{ marginTop: "8px" }}>Click <FaPlus style={{ verticalAlign: "middle" }} /> to add text</div>
                </div>
              )}
              {elements.filter(e => e.type === "text").map(el => (
                <div key={el.id} style={{ background: selectedId === el.id ? "#eff6ff" : "#f9fafb", border: selectedId === el.id ? "1px solid #2563eb" : "1px solid #e5e7eb", borderRadius: "10px", padding: "12px", marginBottom: "10px", transition: "0.2s", display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
                    <div style={{ flex: 1, minWidth: "120px" }}>
                      <div style={{ fontWeight: 500, fontSize: "14px", wordBreak: "break-word" }}>{el.text}</div>
                      <div style={{ fontSize: "12px", color: "#6b7280" }}>{Math.round(el.fontSize)}px</div>
                    </div>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                      <button onClick={() => { setExpandedTextRows(prev => ({ ...prev, [el.id]: !prev[el.id] })); setSelectedId(el.id); }} title="Expand" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaChevronDown /></button>
                      <button onClick={() => setSelectedId(el.id)} title="Select" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>✓</button>
                      <button onClick={() => duplicateElement(el.id)} title="Duplicate" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}><FaClone /></button>
                      <button onClick={() => deleteElement(el.id)} title="Delete" style={{ background: "#f3f4f6", border: "none", padding: "6px", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626" }}><FaTrash /></button>
                    </div>
                  </div>

                  {/* Expand Section */}
                  {expandedTextRows[el.id] && (
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "6px" }}>
                      <input value={el.text} onChange={(ev) => updateElement(el.id, { text: ev.target.value })} style={{ padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }} />
                      <input type="color" value={el.color} onChange={(ev) => updateElement(el.id, { color: ev.target.value })} style={{ width: "50px", height: "35px", border: "none", cursor: "pointer" }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <button onClick={() => setShowTextModal(false)} style={{ background: "#16a34a", color: "#fff", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px" }}><FaCheck />Done</button>
            </div>


            {/* TEXT PROPERTIES SECTION */}
            {selectedId && (
              <div className="section-card">
                <label className="section-title">Formatting</label>
                <label className="input-label">Font Size</label>
                <input type="number" className="input-field" value={fontSize} onChange={e => setFontSize(Number(e.target.value))} />
                {/* <label className="input-label">Font Family</label>
                <label className="input-label">Search Font</label>
                <input type="text" placeholder="Search font..." className="input-field" value={search} onChange={(e) => setSearch(e.target.value)} /> */}
                {/* <label className="input-label">Font Family</label> */}
              {/*  <div style={{ maxHeight: "200px", overflowY: "auto", border: "1px solid #ddd", borderRadius: "8px", padding: "5px", background: "#fff", }}>
                  {filteredFonts.map((font) => (
                    <option key={font.family} value={font.family} style={{ fontFamily: font.family }} >
                      {font.family}
                    </option>
                  ))}
                </div> */}

                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                  <button onClick={() => setIsBold(!isBold)} title="Bold" style={{ background: isBold ? "#2563eb" : "#f3f4f6", color: isBold ? "#fff" : "#000", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}><FaBold /></button>
                  <button onClick={() => setIsItalic(!isItalic)} title="Italic" style={{ background: isItalic ? "#2563eb" : "#f3f4f6", color: isItalic ? "#fff" : "#000", border: "none", padding: "8px 12px", borderRadius: "8px", cursor: "pointer" }}><FaItalic /></button>
                </div>
              </div>
            )}

            <div className="section-card mt-2">
              <label className="section-title">Available Backend Fields</label>
              <div className="text-list">
                {backendTextList.map(el => (
                  <div key={el.id} className="text-list-item" onClick={() => addfrontTextToCard(el)}>
                    <span className="text-preview">{el.text}</span>
                    <span className="text-size-badge"><FaPlus /></span>
                  </div>
                ))}
              </div>
            </div>



          </Modal>


          <Modal isOpen={showImageModal} onRequestClose={() => setShowImageModal(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000 }, content: { top: "50%", left: "50%", right: "auto", bottom: "auto", transform: "translate(-50%, -50%)", width: "90%", maxWidth: "1000px", maxHeight: "90vh", overflowY: "auto", padding: "20px", borderRadius: "16px", border: "none" } }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h5 style={{ margin: 0 }}>Select Image</h5>
              <button onClick={() => setShowImageModal(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}><FaTimes /></button>
            </div>
            <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
              <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Upload New Image</label>
              <div style={{ border: "2px dashed #d1d5db", borderRadius: "12px", padding: "25px", textAlign: "center", background: "#f9fafb" }}>
                <input type="file" accept="image/*" style={{ marginBottom: "10px" }}
                  onChange={e => {
                    const file = e.target.files?.[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = () => {
                      const base64 = reader.result;
                      setSelectedImagee(base64);
                      setCards(prev => ({
                        ...prev,
                        images: [...prev.images, base64]
                      }));
                    };
                    reader.readAsDataURL(file);
                  }}
                />
                <div style={{ color: "#6b7280", fontSize: "13px" }}>Drag & drop or choose image</div>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "15px", marginTop: "15px" }}>
              {/* Shape */}
              <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Shape</label>
                <select value={imageShape} onChange={e => setImageShape(e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }}>
                  <option value="square">Square</option>
                  <option value="rounded">Rounded</option>
                  <option value="circle">Circle</option>
                </select>
              </div>

              {/* Object Fit */}
              <div style={{ background: "#ffffff", borderRadius: "12px", padding: "15px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: 500, fontSize: "14px" }}>Object Fit</label>
                <select value={imageFit} onChange={e => setImageFit(e.target.value)} style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e5e7eb", fontSize: "14px" }}>
                  <option>cover</option>
                  <option>contain</option>
                  <option>fill</option>
                  <option>none</option>
                  <option>scale-down</option>
                </select>
              </div>
            </div>

            {/* Footer */}
            <div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap" }}>
              <button onClick={() => setShowImageModal(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer" }}>Cancel</button>
              <button onClick={addImageElement} style={{ background: "#2563eb", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}><FaCheck />Save</button>
            </div>
          </Modal>




          {/************** Back card */}


          <Modal isOpen={sidebarOpenPanelBack} onRequestClose={() => setSidebarOpenPanelBack(false)} style={{ overlay: { backgroundColor: "rgba(0,0,0,0.4)", zIndex: 1000 }, content: { top: 0, right: 0, left: "auto", bottom: 0, width: "100%", maxWidth: "420px", height: "100vh", padding: "20px", borderRadius: "0px", border: "none", overflowY: "auto", boxShadow: "-6px 0 20px rgba(0,0,0,0.1)" } }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <div>
                <div style={{ fontSize: "16px", fontWeight: 600 }}>Back Card Background</div>
                <div style={{ fontSize: "12px", color: "#6b7280" }}>{cardMm.w} × {cardMm.h} mm</div>
              </div>
              <button onClick={() => setSidebarOpenPanelBack(false)} style={{ background: "#f3f4f6", border: "none", padding: "8px", borderRadius: "8px", cursor: "pointer" }}>✕</button>
            </div>
            <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", marginBottom: "20px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: "14px", marginBottom: "10px", fontWeight: 500 }}>Pick Custom Color</div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <input type="color" value={cardBgBack ?? "#ffffff"} onChange={(ev) => setCardBgBack(ev.target.value)} style={{ width: "55px", height: "40px", border: "none", cursor: "pointer" }} />
                <button onClick={() => setCardBgBack(null)} style={{ background: "#f3f4f6", border: "none", padding: "8px 14px", borderRadius: "8px", cursor: "pointer" }}>Remove Color</button>
              </div>
            </div>
            <div style={{ background: "#f9fafb", borderRadius: "12px", padding: "15px", border: "1px solid #e5e7eb" }}>
              <div style={{ fontSize: "14px", marginBottom: "12px", fontWeight: 500 }}>CMYK Swatches</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(42px, 1fr))", gap: "10px" }}>
                {cmykSwatches.map(s => (
                  <div key={s.hex} onClick={() => setCardBgBack(s.hex)} title={s.name} style={{ width: "100%", aspectRatio: "1 / 1", background: s.hex, borderRadius: "8px", cursor: "pointer", border: cardBgBack === s.hex ? "3px solid #2563eb" : "1px solid #e5e7eb", transition: "0.2s" }} />
                ))}
              </div>
            </div>
            <div style={{ marginTop: "25px", display: "flex", justifyContent: "flex-end" }}>
              <button onClick={() => setSidebarOpenPanelBack(false)} style={{ background: "#2563eb", color: "#fff", border: "none", padding: "10px 18px", borderRadius: "10px", cursor: "pointer", fontWeight: 500 }}>Done</button>
            </div>
          </Modal>




          <Modal isOpen={showTextModalBack} onRequestClose={() => setShowTextModalBack(false)} style={{ content: { maxWidth: "1000px", width: "95%", maxHeight: "90vh", margin: "auto", borderRadius: "12px", padding: "20px", inset: "50% auto auto 50%", transform: "translate(-50%, -50%)", overflow: "auto", }, overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000, }, }}>
            {/* HEADER */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <h5 style={{ margin: 0 }}>Back Card Text</h5>
              <button onClick={() => setShowTextModalBack(false)} style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18 }}><FaTimes /></button>
            </div>
            {/* RESPONSIVE GRID */}
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px", alignItems: "start", }}>
              {/* BACKEND FIELDS */}
              <div style={{ background: "#fff", padding: "15px", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", flexDirection: "column", maxHeight: "300px", overflowY: "auto" }}>
                <h4>Available Backend Fields</h4>
                {backendTextList.map(el => (
                  <div
                    key={el.id}
                    onClick={() => addBackendTextToCard(el)}
                    style={{ padding: 10, marginBottom: 8, borderRadius: 6, cursor: "pointer", background: "#f8f9fa", display: "flex", justifyContent: "space-between", alignItems: "center", }}
                  >
                    <span>{el.text}</span>
                    <FaPlus />
                  </div>
                ))}
              </div>

              {/* FORMATTING */}
              {selectedId && (
                <div style={{ background: "#fff", padding: "15px", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", flexDirection: "column" }}>
                  <h4>Formatting</h4>
                  <label>Font Size</label>
                  <input type="number" value={fontSize} onChange={e => setFontSize(Number(e.target.value))} style={{ width: "100%", padding: 6, marginBottom: 10, borderRadius: 6, border: "1px solid #ddd" }} />
                  <label>Font Color</label>
                  <input type="color" value={fontColor} onChange={e => setFontColor(e.target.value)} style={{ marginBottom: 10 }} />
                  {/* <label>Font Family</label>
                  <input type="text" placeholder="Search fonts..." value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: "100%", padding: 6, marginBottom: 10, borderRadius: 6, border: "1px solid #ddd" }} /> */}

                  {/* <select value={fontFamily} onChange={(e) => setFontFamily(e.target.value)} style={{ width: "100%", padding: 6, marginBottom: 10, borderRadius: 6, border: "1px solid #ddd", fontFamily, }}>
                    {filteredFonts.map((font) => (
                      <option key={font.family} value={font.family} style={{ fontFamily: font.family }} >
                        {font.family}
                      </option>
                    ))}
                  </select> */}

                  <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                    <button onClick={() => setIsBold(!isBold)} style={{ flex: 1, padding: "8px", borderRadius: 6, border: "1px solid #ddd", cursor: "pointer", background: isBold ? "#4f46e5" : "#f1f3f5", color: isBold ? "#fff" : "#000", }}>B</button>
                    <button onClick={() => setIsItalic(!isItalic)} style={{ flex: 1, padding: "8px", borderRadius: 6, border: "1px solid #ddd", cursor: "pointer", background: isItalic ? "#4f46e5" : "#f1f3f5", color: isItalic ? "#fff" : "#000", }}>I</button>
                  </div>

                </div>
              )}

              {/* TEXT MANAGEMENT */}
              <div style={{ background: "#fff", padding: "15px", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", flexDirection: "column", gridColumn: "1 / -1", maxHeight: "400px", overflowY: "auto" }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <strong>Text</strong>
                  <button onClick={addTextBack} style={{ background: "#4f46e5", color: "#fff", border: "none", padding: "8px 14px", borderRadius: 6, cursor: "pointer", display: "flex", alignItems: "center" }}>
                    <FaPlus style={{ marginRight: 6 }} /> Add
                  </button>
                </div>

                {elementsBack.filter(e => e.type === "text").length === 0 && <div>No text yet — click Add</div>}

                {elementsBack.filter(e => e.type === "text").map(el => (
                  <div key={el.id} style={{ border: "1px solid #eee", borderRadius: 8, padding: 12, marginBottom: 10, background: selectedId === el.id ? "#f1f5ff" : "#fff", display: "flex", flexDirection: "column", gap: 8, }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div>
                        <div>{el.text}</div>
                        <small>{Math.round(el.fontSize)}px</small>
                      </div>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button onClick={() => { setExpandedTextRows(prev => ({ ...prev, [el.id]: !prev[el.id] })); setSelectedId(el.id); }} style={{ border: "none", background: "#f1f3f5", padding: "6px 8px", borderRadius: 6, cursor: "pointer" }}><FaChevronDown /></button>
                        <button onClick={() => setSelectedId(el.id)} style={{ border: "none", background: "#f1f3f5", padding: "6px 8px", borderRadius: 6, cursor: "pointer" }}>Select</button>
                        <button onClick={() => duplicateElement(el.id)} style={{ border: "none", background: "#f1f3f5", padding: "6px 8px", borderRadius: 6, cursor: "pointer" }}><FaClone /></button>
                        <button onClick={() => deleteElement(el.id)} style={{ border: "none", background: "#f1f3f5", padding: "6px 8px", borderRadius: 6, cursor: "pointer", color: "red" }}><FaTrash /></button>
                      </div>
                    </div>

                    {/* EXPANDABLE EDIT AREA */}
                    {expandedTextRows[el.id] && (
                      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 6 }}>
                        <input value={el.text} onChange={(ev) => updateElement(el.id, { text: ev.target.value })} style={{ padding: 6, borderRadius: 6, border: "1px solid #ddd", width: "100%" }} />
                        <input type="color" value={el.color} onChange={(ev) => updateElement(el.id, { color: ev.target.value })} style={{ width: "50px", height: "30px", border: "none", padding: 0 }} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div style={{ marginTop: 20, textAlign: "right" }}>
              <button onClick={() => setShowTextModalBack(false)} style={{ background: "#4f46e5", color: "#fff", border: "none", padding: "8px 14px", borderRadius: 6, cursor: "pointer", display: "flex", alignItems: "center" }}>
                <FaCheck style={{ marginRight: 6 }} /> Done
              </button>
            </div>
          </Modal>



          <Modal isOpen={showImageModalBack} onRequestClose={() => setShowImageModalBack(false)} className="rich-modal" overlayClassName="rich-overlay">

            <div className="modal-header">
              <h2>Select Image</h2>
              <button className="close-btn" onClick={() => setShowImageModalBack(false)}>✕</button>
            </div>

            <div className="section-card">
              <label className="section-title">Upload Back Card Image</label>

              <input
                type="file"
                accept="image/*"
                className="file-input"
                onChange={e => {
                  const file = e.target.files?.[0];
                  if (!file) return;
                  const fileUrl = URL.createObjectURL(file);
                  setCards(prev => ({ ...prev, images: [...prev.images, fileUrl] }));
                  setSelectedImageeBack(fileUrl);
                }}
              />

            </div>





            {/* Shape */}
            <div className="section-card">
              <label className="section-title">Shape</label>
              <select className="dropdown" value={imageShape} onChange={e => setImageShape(e.target.value)}>
                <option value="square">Square</option>
                <option value="rounded">Rounded</option>
                <option value="circle">Circle</option>
              </select>
            </div>

            {/* Object Fit */}
            <div className="section-card">
              <label className="section-title">Object Fit</label>
              <select className="dropdown" value={imageFit} onChange={e => setImageFit(e.target.value)}>
                <option>cover</option>
                <option>contain</option>
                <option>fill</option>
                <option>none</option>
                <option>scale-down</option>
              </select>
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button className="btn primary-btn" onClick={addImageElementBack} title="Save"> <FaSave /></button>
              <button className="btn cancel-btn" onClick={() => setShowImageModalBack(false)} title="Cancel"> <FaTimes /></button>
            </div>
          </Modal>
        </div >







































        {/* Main area */}
        < div className="vfc-main" >
          <div className="vfc-topbar">
            <div style={{ fontWeight: 700 }}>Editor</div>
            <div style={{ marginLeft: 12 }} className="small">Card: {mmDisplay}</div>
            <div style={{ marginLeft: "auto", display: "flex", gap: 8, alignItems: "center", }}>

              <button
                className="small"
                onClick={() => setCardMm({ w: 55, h: 88 })}
                style={{
                  backgroundColor: cardMm.w === 55 && cardMm.h === 88 ? "#2563eb" : "#f3f4f6",
                  color: cardMm.w === 55 && cardMm.h === 88 ? "#fff" : "#000",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer"
                }}
              >
                Vertical
              </button>

              <button
                className="small"
                onClick={() => setCardMm({ w: 88, h: 55 })}
                style={{
                  backgroundColor: cardMm.w === 88 && cardMm.h === 55 ? "#2563eb" : "#f3f4f6",
                  color: cardMm.w === 88 && cardMm.h === 55 ? "#fff" : "#000",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer"
                }}
              >
                Horizontal
              </button>
              <button className="small" onClick={() => { if (activeSide === "front") { downloadCard(cardRef, "front-card", "FC"); } else { downloadCard(cardRefBack, "back-card", "BC"); } }} title="Save"><FaSave /> Save</button>
              {/* <button className="small" onClick={() => setCardZoom((z) => Math.max(1, +(z - 0.1).toFixed(2)))}><FaMinus /></button>
              <div style={{ minWidth: 40, textAlign: "center" }}>{Math.round(cardZoom * 83)}%</div>
              <button className="small" onClick={() => setCardZoom((z) => Math.min(1.2, +(z + 0.1).toFixed(2)))}><FaPlus /></button> */}
            </div>
          </div>

          <div className="work" style={{ justifyContent: "center" }}>
            <div className="vfc-a4" onMouseDown={onA4MouseDown} ref={a4Ref}>

              {(activeSide === 'front' || showBoth) && (
                <div className="a4-inner">
                  {showCard && (
                    <div className="card-wrapper" ref={frontCardRef} style={{ transform: `scale(${cardZoom})` }}>
                      <div bounds="parent" size={{ width: cardPxW, height: cardPxH }}>
                        <div ref={cardRef} className="card-node" style={{ background: cardBg ?? "transparent", width: `${cardMm.w}mm`, height: `${cardMm.h}mm`, }}>
                          <div className="card-guides">
                            <div className="bleed" />
                            <div className="bleed-line" />
                            <div className="safe" />
                          </div>
                          <div className="card-elements">
                            {elements.map(el => {
                              const isSelectedForDelete = el.id === deleteCandidateId;
                              const isEditingText = el.id === editingTextId;
                              const commonProps = {
                                key: el.id,
                                bounds: "parent",
                                className: "rnd-box",
                                size: { width: el.width, height: el.height },
                                position: { x: el.x, y: el.y },
                                onDragStart: () => setSelectedId(el.id),
                                onDragStop: (e, d) =>
                                  updateElement(el.id, { x: Math.max(0, Math.round(d.x)), y: Math.max(0, Math.round(d.y)) }),
                                onResizeStop: (e, dir, ref, delta, position) =>
                                  updateElement(el.id, {
                                    width: Math.max(el.type === "text" ? 20 : 10, ref.offsetWidth),
                                    height: Math.max(el.type === "text" ? 16 : 10, ref.offsetHeight),
                                    x: Math.max(0, Math.round(position.x)),
                                    y: Math.max(0, Math.round(position.y)),
                                  }),
                                onClick: ev => { ev.stopPropagation(); setSelectedId(el.id); },
                                onDoubleClick: ev => {
                                  ev.stopPropagation();
                                  if (el.type === "text") {
                                    setEditingTextId(el.id); // edit text
                                  } else {
                                    setDeleteCandidateId(el.id); // show X
                                  }
                                },
                                onMouseEnter: () => setDeleteCandidateId(el.id), // show X on hover
                                onMouseLeave: () => setDeleteCandidateId(null),  // hide X when leaving
                              };

                              return (
                                <Rnd {...commonProps}>
                                  <div style={{ width: "100%", height: "100%", position: "relative" }}>
                                    {el.type === "text" && (
                                      isEditingText ? (
                                        <input autoFocustype="text" value={el.text} onChange={e => updateElement(el.id, { text: e.target.value })} onBlur={() => setEditingTextId(null)} style={{ width: "100%", height: "100%", fontSize: el.fontSize, color: el.color, fontFamily: el.fontFamily, fontWeight: el.isBold ? "bold" : "normal", fontStyle: el.isItalic ? "italic" : "normal" }}
                                        />
                                      ) : (
                                        <div style={{ width: "100%", height: "100%", fontSize: el.fontSize, color: el.color, fontFamily: el.fontFamily, fontWeight: el.isBold ? "bold" : "normal", fontStyle: el.isItalic ? "italic" : "normal" }}>
                                          {el.text}
                                        </div>
                                      )
                                    )}
                                    {/* Image element */}
                                    {el.type === "image" && (
                                      <img src={el.src} style={{ width: "100%", height: "100%", objectFit: el.objectFit || "cover", borderRadius: el.shape === "circle" ? "50%" : el.shape === "rounded" ? "12px" : "0px", }} />
                                    )}

                                    {/* Delete X button for both text and images */}
                                    {isSelectedForDelete && (
                                      <div
                                        onClick={e => {
                                          e.stopPropagation();
                                          setElements(prev => prev.filter(item => item.id !== el.id));
                                          setDeleteCandidateId(null);
                                          if (editingTextId === el.id) setEditingTextId(null);
                                        }}
                                        style={{ position: "absolute", top: -8, right: -8, width: 12, height: 12, borderRadius: "50%", background: "rgba(255,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", zIndex: 1000, }}>
                                        <AiOutlineClose color="white" size={16} />
                                      </div>
                                    )}
                                  </div>
                                </Rnd>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/*** Back Card */}
              {(activeSide === 'back' || showBoth) && (
                <div className="a4-inner">
                  {showCard && (
                    <div className="card-wrapper_back" ref={backCardRef} style={{ transform: `scale(${cardZoom})`, marginLeft: "auto" }}>
                      <div bounds="parent" size={{ width: cardPxW, height: cardPxH }} style={{ zIndex: 30 }}>
                        <div ref={cardRefBack} className="card-node" style={{ background: cardBgBack ?? "transparent", width: `${cardMm.w}mm`, height: `${cardMm.h}mm`, }}>
                          <div className="card-guides">
                            <div className="bleed" />
                            <div className="bleed-line" />
                            <div className="safe" />
                          </div>
                          <div className="card-elements">
                            {elementsBack.map(el => {
                              const isSelectedForDelete = el.id === deleteCandidateIdBack;
                              const isEditingText = el.id === editingTextIdBack;

                              const commonProps = {
                                key: el.id,
                                bounds: "parent",
                                className: "rnd-box",
                                size: { width: el.width, height: el.height },
                                position: { x: el.x, y: el.y },

                                onDragStart: () => setSelectedId(el.id),

                                onDragStop: (e, d) =>
                                  updateElementBack(el.id, {
                                    x: Math.max(0, Math.round(d.x)),
                                    y: Math.max(0, Math.round(d.y)),
                                  }),

                                onResizeStop: (e, dir, ref, delta, position) =>
                                  updateElementBack(el.id, {
                                    width: Math.max(el.type === "text" ? 20 : 10, ref.offsetWidth),
                                    height: Math.max(el.type === "text" ? 16 : 10, ref.offsetHeight),
                                    x: Math.max(0, Math.round(position.x)),
                                    y: Math.max(0, Math.round(position.y)),
                                  }),

                                onClick: ev => {
                                  ev.stopPropagation();
                                  setSelectedId(el.id);
                                },

                                onDoubleClick: ev => {
                                  ev.stopPropagation();
                                  if (el.type === "text") {
                                    setEditingTextIdBack(el.id);
                                  }
                                },

                                onMouseEnter: () => setDeleteCandidateIdBack(el.id),
                                onMouseLeave: () => setDeleteCandidateIdBack(null),
                              };

                              return (
                                <Rnd {...commonProps}>
                                  <div style={{ width: "100%", height: "100%", position: "relative" }}>

                                    {/* TEXT */}
                                    {el.type === "text" && (
                                      isEditingText ? (
                                        <input autoFocustype="text" value={el.text} onChange={e => updateElementBack(el.id, { text: e.target.value })} onBlur={() => setEditingTextIdBack(null)}
                                          style={{ width: "100%", height: "100%", fontSize: el.fontSize, color: el.color, fontFamily: el.fontFamily, fontWeight: el.isBold ? "bold" : "normal", fontStyle: el.isItalic ? "italic" : "normal", border: "none", outline: "none", background: "transparent", }}
                                        />
                                      ) : (
                                        <div style={{ width: "100%", height: "100%", fontSize: el.fontSize, color: el.color, fontFamily: el.fontFamily, fontWeight: el.isBold ? "bold" : "normal", fontStyle: el.isItalic ? "italic" : "normal", }}>
                                          {el.text}
                                        </div>
                                      )
                                    )}

                                    {/* IMAGE */}
                                    {el.type === "image" && (
                                      <img src={el.src} style={{ width: "100%", height: "100%", objectFit: el.objectFit || "cover", borderRadius: el.shape === "circle" ? "50%" : el.shape === "rounded" ? "12px" : "0px", }} />
                                    )}

                                    {/* DELETE ICON (React Icon) */}
                                    {isSelectedForDelete && (
                                      <div
                                        onClick={e => {
                                          e.stopPropagation();
                                          setElementsBack(prev =>
                                            prev.filter(item => item.id !== el.id)
                                          );
                                          setDeleteCandidateIdBack(null);
                                          if (editingTextIdBack === el.id)
                                            setEditingTextIdBack(null);
                                        }}
                                        style={{
                                          position: "absolute",
                                          top: -10,
                                          right: -10,
                                          width: 12,
                                          height: 12,
                                          borderRadius: "50%",
                                          background: "rgba(255,0,0,0.85)",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                          zIndex: 1000,
                                          transition: "0.2s ease",
                                        }}
                                      >
                                        <AiOutlineClose size={16} color="#fff" />
                                      </div>
                                    )}
                                  </div>
                                </Rnd>
                              );
                            })}

                            <div className="_newcard-qr">
                              <QRCodeWithLogo websiteurl={websiteurl} qrCodeSize={qrCodeSize} logoSize={logoSize} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div >























        {/* Right preview / controls */}
        < div className="right-panel" >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <strong>Preview</strong>
            <div style={{ fontSize: 12, color: "#666" }}>{Math.round(cardPos.x)}px, {Math.round(cardPos.y)}px</div>
          </div>

          <div>
            <Button style={{ margin: "10px" }} onClick={() => setActiveSide("front")} title="Front Card"><FaArrowLeft color={activeSide === "front" ? "#ffffff" : "#000000"} /></Button>
            <Button style={{ margin: "10px" }} onClick={() => setActiveSide("back")} title="Back Card" ><FaArrowRight color={activeSide === "back" ? "#ffffff" : "#000000"} /></Button>
            <Button style={{ margin: "10px" }} onClick={() => setShowBoth(b => !b)} title={showBoth ? "Show Single Card" : "Show Both Cards"}><FaEye color={showBoth ? "#ffffff" : "#000000"} /></Button>
          </div>

          <div style={{ marginTop: 8 }}>
            <div style={{ marginBottom: 6, fontSize: 13 }}>Card mm</div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div style={{ padding: 6, border: "1px solid #eee", borderRadius: 8 }}>{cardMm.w.toFixed(2)} mm</div>
              <div style={{ padding: 6, border: "1px solid #eee", borderRadius: 8 }}>{cardMm.h.toFixed(2)} mm</div>
            </div>
          </div>

          <div style={{ marginTop: 12 }}>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="small" onClick={() => setShowCard(s => !s)}>{showCard ? "Hide Card" : "Show Card"}</button>
              {/* <button className="small" onClick={() => { setCardMm({ w: 88, h: 55 }); setCardPos({ x: 40, y: 40 }); }}>Reset Size</button> */}
            </div>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", maxHeight: "300px", overflowY: "auto", paddingRight: "10px", marginTop: "20px", }}>
            {imageUrls.map((img) => (
              <div key={img.id} crossOrigin="anonymous" style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 170, }}>
                {/* Image Card */}
                <div ref={(el) => (cardRefs.current[img.id] = el)} style={{ cursor: "pointer", width: "100%", borderRadius: "10px", overflow: "hidden", boxShadow: "0 4px 10px rgba(0,0,0,0.2)", }}>
                  <img src={img.imageUrl} alt={img.imageName} width={170} style={{ display: "block", borderRadius: "10px" }} />
                </div>
                {/* Card info */}
                <div style={{ marginTop: "8px", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", }}>
                  <span>{img.cardType}</span>
                  <FaDownload style={{ cursor: "pointer", fontSize: "16px", color: "#007bff", }} onClick={() => downloadImage(img.id, img.imageName, img.imageUrl)} />
                </div>
              </div>
            ))}
          </div>
        </div >
      </div >


    </>
  )
}

export default Vfccard
